import Color from 'color';
const { normal } = require('color-blend');
import {
	$S, i18n, hideElement, showElement, getWinBB, getDocBB, getTransitionDurationMs,
	getCssVarVal, getCssValFloat, dpZIndex, getReverseBasePos
} from '../utils/dp-utils';
import DPBoundingBox from './DPBoundingBox';
import goldenRatioPosAlg from '../utils/goldenRatioPosAlg';
import classNames from 'classnames';
import BulletsAnimation from '../../../../includes/assets/js/modules/BulletsAnimation';
import DpitHooks from '../../../../includes/assets/js/modules/DpitHooks';


const IS_DEBUG = false;

export const LAYER_CLASSES = {
	wrapper: 'dpit-wrapper',
	main: 'dpit-main',
	builder: 'dpit-builder',
	highlight: 'dpit-highlight',
	tooltipReference: 'dpit-tooltip-ref',
	tooltip: 'dpit-tooltip',
	tooltipWithNumber: 'dpit-tooltip--with-number',
	tooltipText: 'dpit-tooltip-text',
	arrow: 'dpit-arrow',
	progress: 'dpit-progress',
	progressBar: 'dpit-progress-bar',
	tooltipButtons: 'dpit-tooltip-buttons',
	bullets: 'dpit-bullets',
	rbAnim: 'dpit-rb-anim',
	bulletsAnimModifier: 'anim',
	number: 'dpit-tooltip-number',
	numberOnTooltip: 'dpit-tooltip-number--on-tooltip',
	button: 'dpit-button',
	buttonText: 'dpit-button__text',
	buttonSpacer: 'dpit-button__spacer',
	buttonIco: 'dpit-button__ico',
	buttonTextIco: 'dpit-button__text-ico',
	buttonNext: 'dpit-button--next',
	buttonPrev: 'dpit-button--prev',
	buttonSkip: 'dpit-button--skip',
	buttonFull: 'dpit-button--full',
	buttonDone: 'dpit-button--done',
	overlay: 'dpit-overlay',
	overlayBlurredModifier: 'blurred',
	overlayContainer: 'dpit-overlay-container',
	disableInteraction: 'dpit-disable-interaction',
	hidden: 'dpit-hidden',
	hiddenByOpacityAndWidth: 'dpit-hidden-by-opacity',
	disabled: 'dpit-disabled',
	tourInRun: 'dpit-on',
	builderInRun: 'dpit-bon',
	noTrans: 'dpit-no-trans',
	target: 'dpit-target',
	targetClick: 'dpit-target--click',
	targetBlockEvents: 'dpit-target--block-events',
	targetParent: 'dpit-target-parent',
	targetParentFixed: 'dpit-target-parent--fixed',
	targetParentFixedChild: 'dpit-target-parent--fixed-child',
	targetParentFixedCloser: 'dpit-target-parent--fixed-closer',
	relativePosition: 'dpit-relative-position',
	targetDummy: 'dpit-target-dummy',
	colorAdjusted: 'dpit-color-adjusted',
	bulletPulse: 'dpit-bullet-pulse',
	gelatinePulse: 'dpit-gelatine-pulse',
	isStickyTheme: 'dpit-is-sticky-theme'
};

export const EVENTS = {
	started: 'started',
	onInit: 'onInit',
	onBeforeEnd: 'onBeforeEnd',
	ended: 'ended',
	beforeStepChange: 'beforeStepChange',
	afterStepChange: 'afterStepChange',
	onButtonHover: 'onButtonHover',
	onResize: 'onResize',
	onBeforeRedirect: 'onBeforeRedirect',
	onMobileMenuClose: 'onMobileMenuClose',
	onMobileMenuOpen: 'onMobileMenuOpen',
	onOverlayClick: 'onOverlayClick'
};

export const COMMANDS = {
	goToNext: 'goToNext',
	goToPrev: 'goToPrev',
	goToStep: 'goToStep',
	exit: 'exit',
	setAccent: 'setAccent',
	getScrollSpeed: 'getScrollSpeed',
	setScrollSpeed: 'setScrollSpeed',
	setCoreOptions: 'setCoreOptions'
};

export const CALLBACKS = {
	beforeStepChange: 'beforeStepChange',
	onBeforeShowStep: 'onBeforeShowStep',
	onBeforeEnd: 'onBeforeEnd'
};

export const RESIZE_ACTION = {
	none: 'none',
	soft: 'soft',
	hard: 'hard'
};

const colorToRgbaObject = (color) => {
	return {
		r: color.red(),
		g: color.green(),
		b: color.blue(),
		a: color.alpha()
	};
};

const rgbaObjectToColor = (rgba) => {
	const res = Color.rgb(rgba.r, rgba.g, rgba.b);
	res.alpha(rgba.a);
	return res;
};




export default class DPIntroCore {
	constructor(mainElement, mainCfg, tourId) {
		this.VERSION = '2.0.0';
		if (mainCfg.dpDebugEn) console.log('DPIntroCore ' + this.VERSION);
		this.mainCfg = mainCfg;
		this.mainElement = mainElement;
		const jWrapperEl = $(this.mainElement).closest('.' + LAYER_CLASSES.wrapper);
		this.dpIntroWrapper = jWrapperEl.length ? jWrapperEl[0] : null;
		this.introItems = [];
		this.isPortraitOrientation = null;
		this.activeControl = 'next';
		this.paddingExtensionSize = {
			lr: 0,
			tb: 0
		};
		this.hookBaseArgs = {
			tourId: tourId,
			currentUrl: new URL(window.location)
		};

		$.fn.hasScrollBar = function (x = true, y = true) {
			const hasInX = this.get(0).scrollWidth > this.get(0).clientWidth;
			const hasInY = this.get(0).scrollHeight > this.get(0).clientHeight;
			if (x && y) return hasInX && hasInX;
			else if (x) return hasInX;
			else if (y) return hasInY;
		};

		this.options = {
			dpDebugEn: mainCfg.dpDebugEn,
			labeling: {
				/* Next button label in tooltip box */
				nextLabel: 'Next', // &rarr
				/* Previous button label in tooltip box */
				prevLabel: 'Back',
				/* Cancel button label in tooltip box */
				skipLabel: 'Cancel',
				/* Done button label in tooltip box */
				doneLabel: 'Done',
				button_arrows: 'vector'
			},
			/* Hide previous button always. */
			hide_previous_step_button: false,
			/* Disable navigation to step by click to bullet. */
			disable_navigation_by_bullets: false,
			/* Hide next button always. */
			hideNextAlways: false,
			/* Hide previous button in the first step? Otherwise, it will be disabled button. */
			hidePrev: true,
			/* Hide next button in the last step? Otherwise, it will be disabled button. */
			hideNext: true,
			/* Hide skip button if it is not DONE - in the last step? */
			hide_skip_button: false,
			/* Next CSS class for tooltip boxes */
			tooltipClass: '',
			/* CSS class that is added to the helperLayer */
			highlightClass: '',
			/* Close introduction when pressing Escape button? */
			exitOnEsc: true,
			/* Close introduction when clicking on overlay layer? */
			exitOnOverlayClick: true,
			/* Show step numbers in introduction? */
			showStepNumbers: true,
			/* Let user use keyboard to navigate the tour? */
			keyboardNavigation: true,
			/* Show tour control buttons? */
			showButtons: true,
			/* Show tour bullets? */
			showBullets: true,
			/* Show tour progress? */
			showProgress: false,
			/* Scroll to highlighted element? */
			scrollToElement: true,
			/* Distance of tooltip ... resp tooltip arrow from highlighted box on targeted element */
			tooltipDistanceFromTarget: 7,

			windowMarginCoef: { x: 0.3, y: 0.3 }, // base is arrow size

			targetExtendPaddingPercent: 10,//20,
			targetExtendPaddingMaxPx: 12,

			//Should we scroll the tooltip target element or both?  Options are: 'element', 'tooltip' or all
			scrollTo: 'all',

			/* Set the overlay opacity */
			overlayOpacity: 0.8,
			overlayOpacityCoefWhenScroll: 0.7,

			overlayBlurred: false,
			/* Precedence of positions, when auto is enabled */
			positionPrecedence: ['bottom', 'top', 'right', 'left', 'center'],
			/* Disable an interaction with element? */
			enable_interaction: '1',

			/* additional classes to put on the buttons */
			buttonClass: LAYER_CLASSES.button,

			controlsAutoFocusEnable: true,

			centerTopBottomPosOffset: 80,

			scrollSpeedPerPageMs: 300,
			maxScrollSpeedPerPageMs: 550,


			max_tooltip_width: 0,

			leave_overlay_always: false,

			customTextStylesEn: true,
			scrollEasing: 'swing',
			scrollDurationMsOverride: -1,

			goldenRatioPosAlgEn: true,
			followTargetEn: true,
			resizeRefreshEn: true,

		};
		this.arrowSizes = { width: 30, height: 30 }; // is recalculated
		this.actualizeBoardSizes();
		this.docResizeObserver = new ResizeObserver(this.actualizeBoardSizes);
	}

	doAction(tag, args = {}) {
		if (this.isThisInRun()) {
			DpitHooks.doAction(tag, {
				...this.hookBaseArgs,
				currentStepObj: this.stepObject4Hooks(this.currentTargetItem),
				...args,

			});
		}
	}

	stepObject4Hooks(stepCore) {
		if (!stepCore) return null;
		let res = {
			index: stepCore.step,
			tooltipContent: stepCore.intro,
			tooltipPosition: stepCore.position || 'auto',
			element: stepCore.isDummyElement ? null : stepCore.element,
			selector: stepCore.selector,
			isEnabledInteraction: stepCore.enable_interaction?.val == 1,
		};
		// PRO features
		if (typeof stepCore.url !== 'undefined') {
			res = {
				...res,
				url: stepCore.url,
				altMobileSelector: stepCore.alt_mobile_selector,
				isInMobileMenu: stepCore.is_in_mobile_menu == 1,
				skipOnBigScreen: stepCore.skip_on_big_screen == 1,
				skipOnMobile: stepCore.skip_on_mobile == 1
			};
		}
		return res;
	}

	actualizeDpWrapperSize() {
		$(this.dpIntroWrapper).height(this.docBB.height);
		$(this.dpIntroWrapper).width(this.docBB.width);
	}

	startFollowTarget = (firstInsensitivity = 2, insensitivity = 1, ms = 10) => {
		if (this.followTargetInterval || !this.options.followTargetEn || !this.currentTargetItem || (this.currentTargetItem.isDummyElement && !this.targetDummyBkpEl)) return;
		const isDummyBkpActive = this.currentTargetItem.isDummyElement && this.targetDummyBkpEl;
		const currentTargetEl = isDummyBkpActive ? this.targetDummyBkpEl : this.currentTargetItem.element;
		if (!currentTargetEl || !this.tooltipReferenceLayer) return;

		let lastTargetBB = DPBoundingBox.getElBoundingBox(currentTargetEl);
		const lastRefLayerBB = DPBoundingBox.getElBoundingBox(this.tooltipReferenceLayer);
		let lastRefDiffBB = DPBoundingBox.diff(lastTargetBB, lastRefLayerBB);


		if (this.options.dpDebugEn) console.log('follow start - init target BB:', lastTargetBB);
		this.isFollowTargetEnabled = true;
		let isFirstRun = false;


		this.followTargetInterval = setInterval(() => {
			if (!currentTargetEl || !this.tooltipReferenceLayer || (!$(currentTargetEl).hasClass(LAYER_CLASSES.target) && !isDummyBkpActive)) return;
			const _insensitivity = isFirstRun ? firstInsensitivity : insensitivity;
			const newTargetBB = DPBoundingBox.getElBoundingBox(currentTargetEl);
			const newRefLayerBB = DPBoundingBox.getElBoundingBox(this.tooltipReferenceLayer);
			const newRefDiffBB = DPBoundingBox.diff(newTargetBB, newRefLayerBB);
			const refDiffAbsDiffBB = DPBoundingBox.diffAbs(lastRefDiffBB, newRefDiffBB);
			if (refDiffAbsDiffBB.top > _insensitivity
				|| refDiffAbsDiffBB.left > _insensitivity
				|| refDiffAbsDiffBB.width > _insensitivity
				|| refDiffAbsDiffBB.height > _insensitivity
			) {
				if (this.options.dpDebugEn) console.log(`---  STEP ${this._currentStep} FOLLOW TARGET: TARGET CHANGE POSITION: STARTED ---`);
				this._actualizeTargetPositionBasic(this.currentTargetItem);
				lastRefDiffBB = newRefDiffBB;
				lastTargetBB = newTargetBB;
			}
		}, ms);
	}



	pauseFollowTarget() {
		this.wasFollowTargetEnabled = this.isFollowTargetEnabled;
		this.stopFollowTarget();
	}

	restoreFollowTarget() {
		if (this.wasFollowTargetEnabled) {
			this.startFollowTarget();
		}
	}

	stopFollowTarget() {
		if (this.isFollowTargetEnabled) if (this.options.dpDebugEn) console.log('un-follow');
		this.isFollowTargetEnabled = false;
		clearInterval(this.followTargetInterval);
		this.followTargetInterval = null;
	}

	isStickyTheme = () => {
		let res = false;
		if (this.dpIntroWrapper) {
			res = $(this.dpIntroWrapper).hasClass('sticky');
		}
		return res;
	}


	setStepAsDummy = (step, targetDummyBkpEl = null) => {
		if (step) {
			this.targetDummy = this.mainElement.querySelector('.' + LAYER_CLASSES.targetDummy);
			step.isDummyElement = true;
			if (this.targetDummy === null) {
				this.targetDummy = document.createElement('div');
				this.targetDummy.setAttribute('aria-hidden', 'true');
				this.mainElement.appendChild(this.targetDummy);
			}
			this.targetDummy.className = LAYER_CLASSES.targetDummy;

			step.element = this.targetDummy;
			this.targetDummyBkpEl = targetDummyBkpEl;
			$(this.highlightLayer).addClass('highlight-dummy');
		}
	}

	resetStepAsDummy = (step) => {
		if (step && step.isDummyElement) {
			step.isDummyElement = false;
		}
		this.targetDummyBkpEl = null;
		$(this.highlightLayer).removeClass('highlight-dummy');
	}

	initSteps() {
		var introItems = [];
		if (this.options.steps) {

			this._forEach(this.options.steps, (step) => {
				var stepItem = this._cloneObject(step);

				//set the step
				stepItem.step = introItems.length + 1;

				//use querySelector function only when developer used CSS selector
				stepItem.selector = stepItem.element;

				this.actualizeTargetItemCore(stepItem, false, true);

				stepItem.scrollTo = stepItem.scrollTo || this.options.scrollTo;

				if (typeof (stepItem.enable_interaction) === 'undefined') {
					stepItem.enable_interaction = { val: this.options.enable_interaction };
				}

				if (stepItem.element !== null) {
					introItems.push(stepItem);
				}
			});
		}

		//removing undefined/null elements
		var tempIntroItems = [];
		for (var z = 0; z < introItems.length; z++) {
			if (introItems[z]) {
				// copy non-falsy values to the end of the array
				tempIntroItems.push(introItems[z]);
			}
		}

		introItems = tempIntroItems;
		//Ok, sort all items with given steps
		introItems.sort((a, b) => {
			return a.step - b.step;
		});
		return introItems;

	}

	/**
	* Start a new intro tour
	*
	* @api private
	* @method start
	* @returns {Boolean} Success or not?
	*/
	start = (startStep = 0, backward = false) => {
		this.ending = false;
		//set it to the DPIntroCore object
		this.introItems = this.initSteps();
		this._currentStep = Math.max(-1, Math.min(startStep - 1, this.introItems.length - 1));
		this.doAction(EVENTS.started);

		//add overlay layer to the page
		if (this.addOverlayLayer(false, this.options.overlayBlurred)) {
			//then, start the show
			this.nextStep(backward, true);
			$(this.overlayLayer).on('click', this._onOverlayClick.bind(this));
			this._onKeyDownEventHandler = this._onKeyDown.bind(this);
			$(window).on('keydown', this._onKeyDownEventHandler);
			//for window resize

			$(window).on('resize', this._onResize);


			this.docResizeObserver.observe(document.documentElement);
			this.docResizeObserver.observe(document.body);

		}
		this.isPortraitOrientation = this.isScreenPortraitOrientation(this.winBB);
		return false;
	}

	_onOverlayClick() {
		if (this.options.exitOnOverlayClick === true) {
			this._exitIntro('skip');
		}
		this.doAction(EVENTS.onOverlayClick);
	}

	setOption = (option, value) => {
		this.options[option] = value;
	}

	setOptions(options) {
		this.options = {
			...this.options,
			...options
		};
	}

	/**
	* Go to specific step of introduction
	*
	* @api private
	* @method goToStep
	*/
	goToStep = (step) => {
		if (!Number.isNaN(step)) {
			//because steps starts with zero
			const backward = (step - 2) < this._currentStep;
			this._currentStep = step - 2;
			if (typeof (this.introItems) !== 'undefined') {
				this.nextStep(backward);
			}
		}
	}

	/**
	 * Go to the specific step of introduction with the explicit [data-step] number
	 *
	 * @api private
	 * @method goToStepNumber
	 */
	goToStepNumber = (step) => {
		if (!Number.isNaN(step)) {
			if (this.currentTargetItem) this.updateIterateAfter(this.currentTargetItem, true);
			this._currentStepNumber = step;
			if (typeof (this.introItems) !== 'undefined') {
				this.nextStep();
			}
		}
	}

	/**
	 * Go to next step on intro
	 *
	 * @api private
	 * @method nextStep
	 */
	nextStep = (backward = false, isJustStartedStep = false) => {

		if (typeof (this._currentStepNumber) !== 'undefined') {
			this._forEach(this.introItems, (item, i) => {
				if (item.step === this._currentStepNumber) {
					this._currentStep = i - 1;
					this._currentStepNumber = undefined;
				}
			});
		}

		let previousStep = isJustStartedStep ? null : this.currentTargetItem;
		if (previousStep) this.updateIterateAfter(previousStep, true);

		if (typeof (this._currentStep) === 'undefined') {
			this._currentStep = 0;
		} else {
			++this._currentStep;
		}

		var nextStep = this.introItems[this._currentStep];
		var continueStep = true;


		this.doAction(EVENTS.beforeStepChange, {
			nextStepObj: this.stepObject4Hooks(nextStep),
			backward: backward,
			currentStepObj: this.stepObject4Hooks(previousStep)
		});
		if (this.beforeStepChangeCallback instanceof Function) {
			continueStep = this.beforeStepChangeCallback(this, nextStep, backward, previousStep);
		}

		if (continueStep === -1) {
			--this._currentStep;
			return false;
		}
		else if (continueStep === 0) {
			this.nextStep();
			return;
		}

		if ((this.introItems.length) <= this._currentStep) {
			//end of the intro
			//check if any callback is defined
			this.nextStepOnLastStep();
			return;
		}
		this.activeControl = backward ? 'back' : 'next';
		this.showStepItem(nextStep, false, backward);
	}

	nextStepOnLastStep() {
		this._exitIntro('complete');
		return;
	}

	/**
	 * Go to previous step on intro
	 *
	 * @api private
	 * @method previousStep
	 */
	previousStep = () => {


		if (this._currentStep === 0) {
			return false;
		}
		this.activeControl = 'back';

		let previousStep = this.currentTargetItem;
		if (previousStep) this.updateIterateAfter(previousStep, true);

		--this._currentStep;

		var nextStep = this.introItems[this._currentStep];
		var continueStep = true;

		this.doAction(EVENTS.beforeStepChange, {
			nextStepObj: this.stepObject4Hooks(nextStep),
			backward: true,
			currentStepObj: this.stepObject4Hooks(previousStep)
		});
		if (typeof (this.beforeStepChangeCallback) !== 'undefined') {
			continueStep = this.beforeStepChangeCallback(this, nextStep, true, previousStep);
		}

		if (continueStep === -1) {
			++this._currentStep;
			return false;
		}
		else if (continueStep === 0) {
			this.previousStep();
			return;
		}

		this.showStepItem(nextStep, false, true);
	}




	hideOverlay = () => {
		this.hideLayers(true, false, this.overlayLayer, this.overlayContainer);
	}

	showOverlay = () => {
		showElement(this.overlayLayer, false);
		showElement(this.overlayContainer, 1);
	}

	bringOverlayAboveIntroLayers = (cb) => {

		let overlayLayerBelow = null;
		const overlayContainerBelow = $(this.overlayContainer).clone().addClass(LAYER_CLASSES.hidden).get(0);
		if (overlayContainerBelow) {
			overlayLayerBelow = $(overlayContainerBelow).children('.' + LAYER_CLASSES.overlay).addClass(LAYER_CLASSES.hidden).get(0);
		}
		$(overlayContainerBelow).appendTo(this.mainElement);

		showElement(this.overlayLayer, this.options.overlayOpacity * 0.9);
		showElement(this.overlayContainer, 1);
		showElement(overlayLayerBelow, this.options.overlayOpacity * 0.7);
		showElement(overlayContainerBelow, 1);
		$(this.overlayContainer).css('z-index', dpZIndex(7));

		setTimeout(() => {
			if (cb) cb();
		}, this.overlayContainerTransitionDelayMs);
	}

	hideLayers = (byOpacity, noSpace, ...args) => {
		if (args.length) {
			args.forEach(layer => {
				hideElement(layer, byOpacity, noSpace);
			});
		}
	}

	showLayers = (...args) => {
		if (args.length) {
			args.forEach(layer => {
				showElement(layer);
			});
		}
	}

	hideIntroLayers(hideOverlay = false, hideWrapper = false, noSpace = false, byOpacity = true) {
		this.pauseFollowTarget();
		this.hideLayers(byOpacity, noSpace, this.highlightLayer, this.disableInteractionLayer, this.tooltipReferenceLayer);
		if (hideOverlay) this.hideOverlay();
		$(this.dpIntroWrapper).css('pointer-events', 'none');
		if (hideWrapper) hideElement(this.dpIntroWrapper, byOpacity, noSpace);
	}

	showIntroLayers(showOverlay = false, showWrapper = true) {
		if (showWrapper) $(this.dpIntroWrapper).css('pointer-events', 'unset');
		this.showLayers(this.highlightLayer, this.tooltipReferenceLayer, this.disableInteractionLayer, this.dpIntroWrapper);
		if (showOverlay && !this.hasTargetItemHiddenOverlay(this.currentTargetItem)) {
			this.showOverlay();
		}
		this.restoreFollowTarget();
	}

	_exitIntro(reason) {
		this.exitIntro(false, false, reason);
	}

	/**
	 * Exit from intro
	 *
	 * @api private
	 * @method exitIntro
	 * @param {Object} targetElement
	 * @param {Boolean} force - Setting to `true` will skip the result of beforeExit callback
	 */
	exitIntro = (leaveActiveOverlay = false, force = false, reason = '', isRedirect = false) => {
		this.ending = true;
		var continueExit = true;

		if (this.options.leave_overlay_always) leaveActiveOverlay = true;

		this.doAction(EVENTS.onBeforeEnd, { reason });
		// calling onbeforeexit callback
		// If this callback return `false`, it would halt the process
		if (this.onBeforeExitCallback instanceof Function) {
			continueExit = this.onBeforeExitCallback(this);
		}


		// skip this check if `force` parameter is `true`
		// otherwise, if `onbeforeexit` returned `false`, don't exit the intro
		if (!force && continueExit === false) return;

		if (this.targetDummy) {
			this.targetDummy.parentNode.removeChild(this.targetDummy);
			this.targetDummy = null;
		}
		this.reInitTarget();
		this.hideIntroLayers(!leaveActiveOverlay);
		if (leaveActiveOverlay) this.showOverlay();

		if (isRedirect) return;
		setTimeout(() => {

			//remove disableInteractionLayer
			this._enableInteraction(true);
			//clean listeners
			if (this._onKeyDownEventHandler)
				$(window).off('keydown', this._onKeyDownEventHandler);
			$(window).off('resize', this._onResize);
			this.docResizeObserver.unobserve(document.documentElement);
			this.docResizeObserver.unobserve(document.body);
			$(this.overlayLayer).off('click', this._onOverlayClick);

			$('html').off('scroll wheel DOMMouseScroll mousewheel touchmove', this.stopAutoScrollWhenUserAction);
			$(this.buttonPrevLayer).off('click', this.goToPreviousStep);
			$(this.buttonNextLayer).off('click', this.goToNextStep);
			$(this.buttonSkipLayer).off('click', this.onSkipButtonClick);
			//check if any callback is defined
			this.doAction(EVENTS.ended, { reason });

			//set the step to zero
			this._currentStep = undefined;
			this.exitIntroFinal(leaveActiveOverlay);

		}, 500);
	}

	exitIntroFinal() {
		//this.hideIntroLayers(!leaveActiveOverlay, true); //, true, false
		//$(this._mainElement).find('*').unbind();
		$(this.mainElement).empty();
		this.highlightLayer = null;
		this.overlayContainer = null;
		this._currentStep = undefined;
	}


	isInRun() {
		return $(document.documentElement).hasClass(LAYER_CLASSES.tourInRun);
	}

	isThisInRun() {
		return this.isInRun() && $(this.dpIntroWrapper).hasClass(LAYER_CLASSES.tourInRun);
	}


	reInitTarget = (newTarget = null) => {
		this.resetTargetElement();
		this._clearContrastAdjustment();
		if (newTarget) {
			this.currentTargetItem = newTarget;
		}
	}

	setTargetBBs(targetItem) {

		if (targetItem) {
			if (targetItem.element) {
				this.targetPureBB = DPBoundingBox.getElBoundingBox(targetItem.element, false, targetItem.isFixedPos);

				let paddingExtensionSizeBase = {
					tb: Math.ceil(this.targetPureBB.height * this.options.targetExtendPaddingPercent / 100),
					lr: Math.ceil(this.targetPureBB.width * this.options.targetExtendPaddingPercent / 100)
				};

				this.actualizeNumberBB();

				let minExtensionSize = {
					tb: this.numberLayerBB ? this.numberLayerBB.height / 4 : 0,
					lr: this.numberLayerBB ? this.numberLayerBB.width / 4 : 0
				};

				let maxExtensionSize = {
					tb: this.numberLayerBB ? this.numberLayerBB.height / 3 : this.options.targetExtendPaddingMaxPx,
					lr: this.numberLayerBB ? this.numberLayerBB.width / 3 : this.options.targetExtendPaddingMaxPx
				};

				this.paddingExtensionSize = {
					tb: Math.max(Math.min(paddingExtensionSizeBase.tb, maxExtensionSize.tb), minExtensionSize.tb),
					lr: Math.max(Math.min(paddingExtensionSizeBase.lr, maxExtensionSize.lr), minExtensionSize.lr)
				};
				/*paddingExtensionSize = {
					tb: 0,
					lr: 0
				};*/

				this.targetBB = DPBoundingBox.extendBB(this.targetPureBB, this.paddingExtensionSize.tb, this.paddingExtensionSize.lr);


				this.actualizeBoardSizes();
				if (this.docBB) {
					//const highlightBorderWidth = getCssValFloat(this.highlightLayer, 'border-width', 3);

					const intersectionBB = DPBoundingBox.intersect(this.targetBB, this.docBB);
					if (intersectionBB) this.targetBB = intersectionBB;

				}
				this.visualizeBB('dpit-vis-target-bb', this.targetBB, 'rgba(0, 0, 255, 0.3)', this.currentTargetItem?.isFixedPos, !this.currentTargetItem?.isFixedPos);
				return this.targetBB;
			}
		}
		return false;

	}

	_pauseTour = () => {
		this._enableInteraction();
		this.reInitTarget();
		this.hideIntroLayers(true);
	}

	unsubscribeEvent(eventId, providedCallback) {
		this.subscribeEvent(eventId, providedCallback, true);
	}

	subscribeEvent(eventId, providedCallback, unsubscribe = false) {
		if (typeof (providedCallback) === 'function') {
			if (eventId in EVENTS) {
				if (unsubscribe) DpitHooks.removeAction(eventId, providedCallback);
				else DpitHooks.addAction(eventId, providedCallback);
			}
			else {
				throw new Error(`Provided event name ${eventId} was not recognized. Choose from: ${EVENTS.values().join(',')}`);
			}
		}
		else {
			throw new Error(`Provided callback for ${eventId} was not a function.`);
		}
	}

	setCallback = (callbackId, providedCallback) => {
		if (typeof (providedCallback) === 'function' || providedCallback === null) {
			switch (callbackId) {
				case CALLBACKS.beforeStepChange: this.beforeStepChangeCallback = providedCallback; break;
				case CALLBACKS.onBeforeShowStep: this.onBeforeShowStepCallback = providedCallback; break;
				case CALLBACKS.onBeforeEnd: this.onBeforeExitCallback = providedCallback; break;
				default: throw new Error(`Provided callback name ${callbackId} was not recognized.`);
			}
		}
		else {
			throw new Error(`Provided callback for ${callbackId} was not a function.`);
		}
	}


	activateBullet(idx) {
		$(this.bulletsLayer).find('li.active').removeClass('active');
		$(this.bulletsLayer).find(`li[data-step-number="${idx}"]`).addClass('active').attr('aria-selected', 'true');
	}

	setNotVisibleRefBullet(idx, notVisible = true) {
		if (notVisible) $(this.bulletsLayer).find(`li[data-step-number="${idx}"]`).addClass('not-visible-ref');
		else {
			$(this.bulletsLayer).find(`li[data-step-number="${idx}"]`).removeClass('not-visible-ref');
			if (this.visibleLastStep && idx > this.visibleLastStep) {
				this.visibleLastStep = idx;
			}
			if (this.visibleFirstStep && idx < this.visibleFirstStep) {
				this.visibleFirstStep = idx;
			}
		}
	}

	getNotVisibleStepCnt() {
		return $(this.bulletsLayer).find('li.not-visible-ref').length;
	}

	createBullet = (step, roleLinkList = true, isActive = false, onClickCallback = null) => {
		var innerLi = document.createElement('li');
		if (roleLinkList) {
			innerLi.setAttribute('role', 'tab');
			innerLi.tabIndex = 0;
			innerLi.title = i18n('step', this.mainCfg.i18n) + ' ' + step;
		}

		if (onClickCallback) innerLi.onclick = onClickCallback;

		if (isActive) {
			innerLi.className = 'active';
			innerLi.setAttribute('aria-selected', 'true');
		}
		else {
			innerLi.setAttribute('aria-selected', 'false');
		}

		if (roleLinkList) {
			innerLi.setAttribute('data-step-number', step);
		}

		var innerNumber = document.createElement('div');
		innerNumber.innerHTML = step;
		innerLi.appendChild(innerNumber);

		return innerLi;
	}

	createBullets = (className = LAYER_CLASSES.bullets, showBullets = false, roleLinkList = true, activeIdx = 0, onClickCallback = null) => {
		const bulletsLayer = document.createElement('div');
		$(bulletsLayer).addClass(className);

		var ulContainer = document.createElement('ul');
		if (roleLinkList) ulContainer.setAttribute('role', 'tablist');

		this._forEach(this.introItems, (item, i) => {
			ulContainer.appendChild(this.createBullet(item.step, roleLinkList, i === activeIdx, onClickCallback));
		});
		if (!showBullets) bulletsLayer.style.display = 'none';
		bulletsLayer.appendChild(ulContainer);
		return bulletsLayer;
	}

	actualizeBoardSizes = (boardSizesOnly = false) => {
		if (!boardSizesOnly) {
			this.docBB = getDocBB(this.mainCfg.mobile_break_points?.mobile);
			this.winBB = getWinBB(this.mainCfg.mobile_break_points?.mobile);
			this.isMobileSize = this.getIsMobileSize();
			//this.visualizeBB('dpit-vis-doc-bb', this.docBB, 'rgba(0,255,0,0.3)', false, true);
		}
		if (this.arrowLayer) {
			this.arrowSizes = { width: $(this.arrowLayer).outerWidth(), height: $(this.arrowLayer).outerHeight() };
		}

		this.maxDocBoardBB = this.getMaxBoardBB(true, this.currentTargetItem?.isFixedPos, this.targetBB, true);
		//this.visualizeBB('dpit-vis-max-doc-board-bb', DPBoundingBox.intersect(this.maxDocBoardBB, this.docBB), 'rgba(255,0,0,0.3)', this.currentTargetItem?.isFixedPos, true);
		this.actualizeScreenArea();
	}


	actualizeScreenArea() {
		this.maxScreenArea = this.getMaxBoardBB(false, this.currentTargetItem?.isFixedPos, this.targetBB, true);
		//if (this.options.dpDebugEn) console.log('MAX WIN BOARD:', this.maxScreenArea);
		this.visualizeBB('dpit-vis-max-screen-board-bb', this.maxScreenArea, 'rgba(255,0,255,0.2)', true, this.currentTargetItem?.isFixedPos, false);
	}

	hasOrientationChanged(currentWinBB, oldWinBB) {
		return this.isScreenPortraitOrientation(currentWinBB) !== this.isScreenPortraitOrientation(oldWinBB);
	}

	isBigResizeChange(currentWinBB, oldWinBB, relativeThreshold = 0.4) {
		const currentArea = DPBoundingBox.area(currentWinBB);
		const oldArea = DPBoundingBox.area(oldWinBB);
		return Math.abs(currentArea - oldArea) > relativeThreshold * currentArea;
	}

	getResizeAction(currentWinBB, oldWinBB) {
		let res = RESIZE_ACTION.soft;
		const hasOrientationChanged = this.hasOrientationChanged(currentWinBB, oldWinBB);
		const isBigScreenSizeChange = this.isBigResizeChange(currentWinBB, oldWinBB);
		if (!hasOrientationChanged && (currentWinBB.height != this.winBB.height) && !isBigScreenSizeChange) {
			if (currentWinBB.width === this.winBB.width) {
				// Android Chrome address bar 
				res = RESIZE_ACTION.none;
				if (currentWinBB.height < this.winBB.height) {
					// Android Chrome address bar has appeared
				} else {
					// Android Chrome address bar has disappeared
				}
			} else {
				res = RESIZE_ACTION.soft;
			}

		} else if (hasOrientationChanged || isBigScreenSizeChange) {
			res = RESIZE_ACTION.hard;
		}
		return res;
	}


	resizeRefresh(sizes, introLayersHasBeenHidden) {

		const resizeAction = this.getResizeAction(sizes.currentWinSize, sizes.oldWinSize);
		this.winBB = { ...sizes.currentWinSize };

		this.pauseFollowTarget();
		this.actualizeBoardSizes();
		// iframe inside tooltip - fullscreen
		if (!(this._isIframeInTooltip && this.tooltipBB.width !== this.tooltipBBRel.width)) {
			if (this.options.dpDebugEn) console.log('Resize:', sizes, 'Action:', resizeAction);
			this.doAction(EVENTS.onResize, sizes);
			switch (resizeAction) {
				case RESIZE_ACTION.hard: this.refresh(); break;
				case RESIZE_ACTION.soft: this._actualizeTargetPositionBasic(this.currentTargetItem, false, false, true, false); break;
			}
		}
		if (introLayersHasBeenHidden) this.showIntroLayers();
		this.tooltipBBRel = this.tooltipBB;
		this.restoreFollowTarget();
	}

	isScreenPortraitOrientation(winBB) {
		return winBB ? winBB.height > winBB.width : false;
	}

	_onResize = () => {
		if (this.options.resizeRefreshEn) {
			if (this._resizeTimeout) {
				this.restartResizeTimeout();
			}
			else if (!this.disableOnResize) {
				// First resize event after non resize - active period
				this.pauseFollowTarget();
				this.disableOnResize = true;
				this.oldWinBB = { ...this.winBB };
				this.oldDocBB = { ...this.docBB };
				this.restartResizeTimeout();
				this.disableOnResize = false;
			}
		}
	}

	restartResizeTimeout() {
		const currentWinSize = getWinBB(this.mainCfg.mobile_break_points?.mobile);
		const hasOrientationChanged = this.hasOrientationChanged(currentWinSize, this.oldWinBB);
		const hideIntroLayers = hasOrientationChanged || currentWinSize.width !== this.oldWinBB.width;
		if (hideIntroLayers) {
			this.hideIntroLayers();
		}
		if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
		this._resizeTimeout = setTimeout(() => {

			this.resizeRefresh({
				oldWinSize: this.oldWinBB,
				currentWinSize: getWinBB(this.mainCfg.mobile_break_points?.mobile),
				oldSize: this.oldDocBB,
				currentSize: getDocBB(this.mainCfg.mobile_break_points?.mobile)
			}, hideIntroLayers);
			this._resizeTimeout = null;
		}, 300);
	}

	_onKeyDown(e) {
		if (this.options.keyboardNavigation) {
			var code = e.key ?? e.keyCode;
			let isHideNextByCurrentStepMeta = this.isHideNextByCurrentStepMeta();

			// if code/e.which is null
			code ??= e.charCode;
			const isLastStep = this.introItems.length - 1 === this._currentStep;
			if ((code === 'Escape' || code === 27) && this.options.exitOnEsc === true) {
				//escape key pressed, exit the intro
				//check if exit callback is defined
				this._exitIntro('skip');
			} else if (code === 'ArrowLeft' || code === 37) {
				//left arrow
				if (!this.options.hide_previous_step_button) this.previousStep();
			} else if (code === 'ArrowRight' || code === 39) {
				//right arrow
				if (!this.options.hideNextAlways && !isLastStep && !isHideNextByCurrentStepMeta) this.nextStep();
			} else if (code === 'Enter' || code === 13) {
				//srcElement === ie
				var target = e.target || e.srcElement;
				if (!this.options.hide_previous_step_button && target === this.buttonPrevLayer) {
					//user hit enter while focusing on previous button
					this.previousStep();
				} else if (target === this.buttonSkipLayer) {
					//user hit enter while focusing on skip button
					this._exitIntro('complete');
				} else if (target && target.getAttribute('data-step-number')) {
					// user hit enter while focusing on step bullet
					target.click();
				} else if (!this.options.hideNextAlways && !isLastStep && !isHideNextByCurrentStepMeta) {
					//default behavior for responding to enter
					this.nextStep();
				}

				//prevent default behaviour on hitting Enter, to prevent steps being skipped in some browsers
				if (e.preventDefault) {
					e.preventDefault();
				} else {
					e.returnValue = false;
				}
			}
		}
	}

	/*
	  * makes a copy of the object
	  * @api private
	  * @method _cloneObject
	 */
	_cloneObject = (object) => {
		if (object === null || typeof (object) !== 'object' || typeof (object.nodeType) !== 'undefined') {
			return object;
		}
		var temp = {};
		for (var key in object) {
			if (typeof (window.jQuery) !== 'undefined' && object[key] instanceof window.jQuery) {
				temp[key] = object[key];
			} else {
				temp[key] = this._cloneObject(object[key]);
			}
		}
		return temp;
	}

	setWinMargins = (targetBB) => {
		let mobileSizeCoef = 1;
		if (this.isMobileSize) {
			mobileSizeCoef = 0.5;
		}
		let res = {
			left: this.arrowSizes.width * this.options.windowMarginCoef.x * mobileSizeCoef,
			right: this.arrowSizes.height * this.options.windowMarginCoef.x * mobileSizeCoef,
			top: this.arrowSizes.height * this.options.windowMarginCoef.y * mobileSizeCoef,
			bottom: this.arrowSizes.height * this.options.windowMarginCoef.y * mobileSizeCoef
		};
		if (targetBB) {
			res.left = Math.min(res.left, targetBB.left);
			res.right = Math.min(res.right, this.docBB.right - targetBB.right);
			res.top = Math.min(res.top, targetBB.top);
			res.bottom = Math.min(res.bottom, this.docBB.bottom - targetBB.bottom);
		}
		return res;
	}

	visualizeBB(id, bb, color = 'rgba(255,0,0,0.5)', fixed, adjustHeightByAdminBar = false) {
		/*
		const selector = '#' + id;
		if (!$(selector).length) {
			const boardEl = document.createElement('div');
			boardEl.id = id;
			//document.documentElement.append(boardEl);
			this.dpIntroWrapper.append(boardEl);
		}
		let adminBarHeight = $('#wpadminbar').outerHeight();
		if (isNaN(adminBarHeight)) adminBarHeight = 0;
		const boardToVisualize = DPBoundingBox.actualizeHeightAndWidth(bb);

		$(selector).css({
			position: fixed ? 'fixed' : 'absolute',
			backgroundColor: color,
			top: (boardToVisualize.top) - (adjustHeightByAdminBar ? adminBarHeight : 0) + 'px',
			left: boardToVisualize.left + 'px',
			width: boardToVisualize.width + 'px',
			height: (boardToVisualize.height ) + 'px', //(adjustHeightByAdminBar ? adminBarHeight : 0)
			pointerEvents: 'none',
				zIndex: 'calc(var(--dp-z-index-base) + 3)',
		}); */

	}

	getMaxBoardBB = (isDocumentSize = true, isFixedPos = false, targetBB = null, includeWinMargin = true) => {
		this.windowMargins = includeWinMargin ? this.setWinMargins(targetBB) : DPBoundingBox.empty();
		/*this.windowMargins = {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		};*/
		let maxROI = {
			top: this.windowMargins.top,
			right: (isDocumentSize ? this.docBB.right : this.winBB.right) - this.windowMargins.right,
			bottom: (isDocumentSize ? this.docBB.bottom : this.winBB.bottom) - this.windowMargins.bottom,
			left: this.windowMargins.left
		};

		if (isDocumentSize && isFixedPos) {
			maxROI = {
				top: this.windowMargins.top,
				right: this.winBB.width - 1 - this.windowMargins.right,
				bottom: this.winBB.height - 1 - this.windowMargins.bottom,
				left: this.windowMargins.left
			};
		}
		else if (!isDocumentSize && this.isStickyTheme()) {
			const stickyTooltipOffset = this._getStickyTooltipOffset();
			maxROI.top += stickyTooltipOffset.top;
			maxROI.bottom -= stickyTooltipOffset.bottom;
		}
		return DPBoundingBox.actualizeHeightAndWidth(maxROI);
	}

	/**
	 * Render tooltip box in the page
	 *
	 * @api private
	 * @method placeTooltip
	 * @param {HTMLElement} targetElement
	 */
	placeTooltip = (targetItem, placeTooltipIterations = 0, isCrowdedPos = {}, useLastPosition = false) => {


		let tooltipCssClass = '';
		let prevIterationTooltipPos = null;
		this.tooltipLayer.style.marginLeft = null;
		this.tooltipLayer.style.marginTop = null;
		this.tooltipLayer.style.borderTopLeftRadius = null;
		this.tooltipLayer.style.borderTopRightRadius = null;
		this.tooltipLayer.style.borderBottomLeftRadius = null;
		this.tooltipLayer.style.borderBottomRightRadius = null;

		if (placeTooltipIterations === 0) {
			this.tooltipLayer.style.top = null;
			this.tooltipLayer.style.right = null;
			this.tooltipLayer.style.bottom = null;
			this.tooltipLayer.style.left = null;
			this.tooltipLayer.style.width = null;
			this.tooltipLayer.style.height = null;
			this.tooltipTextLayer.style.maxHeight = null;
		}
		else {
			prevIterationTooltipPos = { ...this.tooltipPos };
		}

		if (targetItem?.hidden_meta?.ext?.build_with_wp_editor === '1') {
			$(this.tooltipTextLayer).addClass('dpit-tooltip-text--rt');
		}
		else {
			$(this.tooltipTextLayer).removeClass('dpit-tooltip-text--rt');
		}

		if (this.options.customTextStylesEn) {
			$(this.tooltipTextLayer).addClass('dpit-tooltip-text--cs');
		}
		else {
			$(this.tooltipTextLayer).removeClass('dpit-tooltip-text--cs');
		}

		this.actualizeScreenArea();
		this.actualizeTooltipMaxWidth();

		//prevent error when `this._currentStep` is undefined
		if (!targetItem) return;


		//if we have a custom css class per step
		if (typeof (targetItem.tooltipClass) === 'string') {
			tooltipCssClass = targetItem.tooltipClass;
		} else {
			tooltipCssClass = this.options.tooltipClass;
		}

		this.tooltipLayer.className = LAYER_CLASSES.tooltip;
		$(this.tooltipLayer).addClass(tooltipCssClass.replace(/^\s+|\s+$/g, ''));
		if (this.options.showProgress) {
			$(this.tooltipLayer).addClass(LAYER_CLASSES.tooltip + '--with-progress-bar');
		}

		//const highlightOutlineSize = getCssValFloat(this.highlightLayer, 'outline-width', 3);
		const arrowSizes = {
			width: $(this.arrowLayer).outerWidth(),
			height: $(this.arrowLayer).outerHeight()
		};
		const arrowHalfSizes = { width: arrowSizes.width / 2, height: arrowSizes.height / 2 };

		this.tooltipBB = DPBoundingBox.getElBoundingBox(this.tooltipLayer, false, targetItem?.isFixedPos);



		this.tooltipPos = useLastPosition && this.tooltipPos ? this.tooltipPos : this._determineAutoPosition(
			targetItem,
			arrowSizes,
			isCrowdedPos
		);

		const isLeftOrRight = ['left', 'right'].includes(this.tooltipPos.base);



		const tooltipRadius = getCssValFloat(this.tooltipLayer, 'border-top-right-radius', 0);

		const arrowLayerPos = {
			top: arrowHalfSizes.height - this.options.tooltipDistanceFromTarget,
			left: this.targetBB.width / 2 - arrowHalfSizes.width
		}; // top, center aligned

		const tooltipLayerPos = { top: 0, left: 0 };
		const desiredNumberPos = { x: 'right', y: 'top', onTooltip: false };

		let isNeededNextIteration = false;
		this.arrowLayer.style.display = '';
		if (!this.isStickyTheme()) {
			this.arrowLayer.className = LAYER_CLASSES.arrow;
			let arrowPos = 'top';

			//tooltipPos.base = 'right';
			//tooltipPos.align = 'top';
			// basic position
			switch (this.tooltipPos.base) {
				case 'top':
					arrowPos = 'bottom';
					desiredNumberPos.y = 'bottom';
					tooltipLayerPos.top = - this.tooltipBB.height - arrowHalfSizes.height - this.options.tooltipDistanceFromTarget;
					arrowLayerPos.top = - arrowHalfSizes.height - 1 - this.options.tooltipDistanceFromTarget;
					break;
				case 'right':
					desiredNumberPos.x = 'left';
					arrowPos = 'left';
					tooltipLayerPos.left = (this.targetBB.width - 1 + arrowHalfSizes.width + this.options.tooltipDistanceFromTarget);
					if (placeTooltipIterations === 0) this.tooltipLayer.style.width = this.tooltipPos.width + 'px';
					arrowLayerPos.left = this.targetBB.width - arrowHalfSizes.width + this.options.tooltipDistanceFromTarget;
					break;
				case 'bottom':
					arrowPos = 'top';
					desiredNumberPos.y = 'top';
					tooltipLayerPos.top = (this.targetBB.height - 1 + arrowHalfSizes.height + this.options.tooltipDistanceFromTarget);
					arrowLayerPos.top = this.targetBB.height + this.options.tooltipDistanceFromTarget - arrowHalfSizes.height;

					break;
				case 'left':
					arrowPos = 'right';
					desiredNumberPos.x = 'right';
					tooltipLayerPos.left = (- arrowHalfSizes.width - this.tooltipPos.width - this.options.tooltipDistanceFromTarget);
					if (placeTooltipIterations === 0) this.tooltipLayer.style.width = this.tooltipPos.width + 'px';
					arrowLayerPos.left = tooltipLayerPos.left + this.tooltipPos.width - 1;
					break;
				case 'center':
					this.arrowLayer.style.display = 'none';
					desiredNumberPos.onTooltip = true;
					desiredNumberPos.x = 'right';
					desiredNumberPos.y = 'top';
					tooltipLayerPos.left = (this.targetBB.width - this.tooltipBB.width) / 2;
					break;
			}

			let arrowVsTargetAddCoef = 0;
			if (this.tooltipPos.base !== 'center') {
				if (isLeftOrRight) {
					arrowLayerPos.top = this.targetBB.height / 2 - arrowHalfSizes.height;
					if (arrowSizes.height > this.targetBB.height) {
						arrowVsTargetAddCoef = arrowSizes.height - this.targetBB.height;
					}
				}
				else {
					arrowLayerPos.left = this.targetBB.width / 2 - arrowHalfSizes.width;
				}
			}

			const reversedBasePos = getReverseBasePos(this.tooltipPos.base);
			// align
			switch (this.tooltipPos.align) {
				case 'left':
					desiredNumberPos.x = 'right';
					if (this.tooltipPos.base != 'center' && tooltipRadius > 0) {
						if (arrowLayerPos.left < tooltipLayerPos.left + tooltipRadius) {
							this.tooltipLayer.style[`border-${reversedBasePos}-left-radius`] = (Math.max(Math.min(arrowLayerPos.left - tooltipLayerPos.left, tooltipRadius), 0)) + 'px';
						}
					}
					break;
				case 'center':
					desiredNumberPos.x = 'right';
					tooltipLayerPos.left = (this.targetBB.width - this.tooltipBB.width) / 2;
					break;
				case 'right': {
					desiredNumberPos.x = 'left';
					tooltipLayerPos.left = this.targetBB.width - this.tooltipBB.width;
					if (this.tooltipPos.base != 'center' && tooltipRadius > 0) {
						const tooltipRight = tooltipLayerPos.left + this.tooltipBB.width - 1;
						const arrowRight = arrowLayerPos.left + arrowSizes.width - 1;
						if (arrowRight > tooltipRight - tooltipRadius) {
							this.tooltipLayer.style[`border-${reversedBasePos}-right-radius`] = (Math.max(Math.min(tooltipRight - arrowRight, tooltipRadius), 0)) + 'px';
						}
					}
					break;
				}
				case 'top':
					desiredNumberPos.y = 'bottom';
					tooltipLayerPos.top = 0;
					if (this.targetBB.height > (this.tooltipBB.height / 1.8)) {
						arrowLayerPos.top = this.tooltipBB.height / 2 - arrowHalfSizes.height - arrowVsTargetAddCoef;
						this.tooltipPos.align = 'middle';
					}
					if (this.tooltipPos.base === 'center') {
						tooltipLayerPos.top = this.options.centerTopBottomPosOffset;
					}
					else if (tooltipRadius > 0) {
						if (arrowLayerPos.top < tooltipLayerPos.top + tooltipRadius) {
							this.tooltipLayer.style[`border-top-${reversedBasePos}-radius`] = (Math.max(Math.min(arrowLayerPos.top - tooltipLayerPos.top, tooltipRadius), 0)) + 'px';
						}
					}
					break;
				case 'middle':
					desiredNumberPos.y = 'top';
					tooltipLayerPos.top = (this.targetBB.height - this.tooltipBB.height) / 2;
					break;
				case 'bottom': {
					desiredNumberPos.y = 'top';
					tooltipLayerPos.top = this.targetBB.height - this.tooltipBB.height + arrowVsTargetAddCoef;
					if (this.targetBB.height > this.tooltipBB.height / 1.8) {
						arrowLayerPos.top = this.targetBB.height - this.tooltipBB.height / 2 - arrowHalfSizes.height;
						this.tooltipPos.align = 'middle';
					}
					if (this.tooltipPos.base != 'center' && tooltipRadius > 0) {
						const tooltipBottom = tooltipLayerPos.top + this.tooltipBB.height - 1;
						const arrowBottom = arrowLayerPos.top + arrowSizes.height - 1;
						if (arrowBottom > tooltipBottom - tooltipRadius) {
							this.tooltipLayer.style[`border-bottom-${reversedBasePos}-radius`] = (Math.max(Math.min(tooltipBottom - arrowBottom, tooltipRadius), 0)) + 'px';
						}
					}
					break;
				}

			}






			/*tooltipLayerPos.left -= (2 * highlightOutlineSize);
			tooltipLayerPos.top -= (2 * highlightOutlineSize);
			arrowLayerPos.left -= (2 * highlightOutlineSize);
			arrowLayerPos.top -= (2 * highlightOutlineSize);*/

			this.tooltipLayer.style.left = tooltipLayerPos.left + 'px';
			this.tooltipLayer.style.top = tooltipLayerPos.top + 'px';
			if (this.tooltipPos.base) $(this.tooltipLayer).addClass(`${LAYER_CLASSES.tooltip}--${this.tooltipPos.base}`);
			if (this.tooltipPos.align) $(this.tooltipLayer).addClass(`${LAYER_CLASSES.tooltip}--${this.tooltipPos.align}-aligned`);
			this.tooltipBB = DPBoundingBox.getElBoundingBox(this.tooltipLayer, false, targetItem?.isFixedPos);


			this.arrowLayer.style.left = arrowLayerPos.left + 'px';
			this.arrowLayer.style.top = arrowLayerPos.top + 'px';
			$(this.arrowLayer).addClass(`${LAYER_CLASSES.arrow}--${arrowPos}`);
			$(this.arrowLayer).addClass(`${LAYER_CLASSES.arrow}--${this.tooltipPos.align}-aligned`);

			if (['top', 'bottom'].includes(this.tooltipPos.base)) {

				let diff = 0;
				let isOverLeft = this.tooltipBB.left < this.maxDocBoardBB.left;
				let isOverRight = this.tooltipBB.right > this.maxDocBoardBB.right;

				if (isOverLeft /*&& this.targetBB.left > this.maxDocBoardBB.left*/) {
					diff = Math.abs(this.maxDocBoardBB.left - this.tooltipBB.left);
					if (this.options.dpDebugEn) console.log('adjusting top bottom position: isOverLeft');
					$(this.tooltipLayer).offset({ left: this.maxDocBoardBB.left });
					this.tooltipBB = DPBoundingBox.getElBoundingBox(this.tooltipLayer, false, targetItem?.isFixedPos);
					isOverRight = this.tooltipBB.right > this.maxDocBoardBB.right;
					if (isOverRight) {
						this.tooltipLayer.style.width = (this.tooltipBB.width - (2 * diff)) + 'px';
					}
				}
				else if (isOverRight/* && this.targetBB.right < this.maxDocBoardBB.right*/) {
					if (this.options.dpDebugEn) console.log('adjusting top bottom position: isOverRight');
					const newLeft = this.maxDocBoardBB.right - this.tooltipBB.width;
					diff = Math.abs(newLeft - this.tooltipBB.left);
					$(this.tooltipLayer).offset({ left: newLeft });
					this.tooltipBB = DPBoundingBox.getElBoundingBox(this.tooltipLayer, false, targetItem?.isFixedPos);
					isOverLeft = this.tooltipBB.left < this.maxDocBoardBB.left;
					if (isOverLeft) {
						this.tooltipLayer.style.width = (this.tooltipBB.width - (2 * diff)) + 'px';
					}
				}
			}


			if (
				this.options.goldenRatioPosAlgEn
				&& placeTooltipIterations < 3
				&& !(placeTooltipIterations > 0 && prevIterationTooltipPos.base === this.tooltipPos.base && prevIterationTooltipPos.align === this.tooltipPos.align)
			) {
				let basePositions = ['left', 'right', 'bottom', 'top'].filter(val => !isCrowdedPos[val]);
				if (basePositions.includes(this.tooltipPos.base)) {
					const goldenRatioPosAlgRes = goldenRatioPosAlg(
						this.targetBB,
						this.tooltipBB,
						this.tooltipLayer,
						this.tooltipPos,
						this.maxScreenArea,
						this.maxDocBoardBB,
						targetItem?.isFixedPos,
						this.options.dpDebugEn
					);
					isNeededNextIteration = goldenRatioPosAlgRes.wasPosAdjusted;
					this.tooltipBB = { ...goldenRatioPosAlgRes.tooltipBB };
					if (goldenRatioPosAlgRes.isOverHeight) isCrowdedPos[this.tooltipPos.base] = true;
				}

			}
			if (!isCrowdedPos[this.tooltipPos.base]) {
				const adjustIsCrowdedPos = this.adjustFixedPositionsOutOfWindow(targetItem);
				if (adjustIsCrowdedPos) {
					isNeededNextIteration = true;
					isCrowdedPos[this.tooltipPos.base] = true;
				}
			}
		}
		else {
			// fixed bottom/top banner tooltip
			const stickyTooltipHeight = this._getStickyTooltipOffset();
			let shouldActualizeScreenArea = false;
			if (this.targetBB.top + this.targetBB.height > this.maxDocBoardBB.bottom - stickyTooltipHeight.bottom && !targetItem.isDummyElement) {
				if (!$(this.tooltipLayer).hasClass(`${LAYER_CLASSES.tooltip}--on-top`)) shouldActualizeScreenArea = true;
				$(this.tooltipLayer).addClass(`${LAYER_CLASSES.tooltip}--on-top`);
				$(this.mainElement).addClass(`${LAYER_CLASSES.main}--on-top`);
			}
			else {
				if ($(this.tooltipLayer).hasClass(`${LAYER_CLASSES.tooltip}--on-top`)) shouldActualizeScreenArea = true;
				$(this.tooltipLayer).removeClass(`${LAYER_CLASSES.tooltip}--on-top`);
				$(this.mainElement).removeClass(`${LAYER_CLASSES.main}--on-top`);
			}
			if (shouldActualizeScreenArea) this.actualizeScreenArea();

			this.isTargetElementInsideMaxScreenArea = this.isElementInsideMaxScreenArea(this.currentTargetItem?.element);
			if (!this.isTargetElementInsideMaxScreenArea) {
				desiredNumberPos.onTooltip = true;
				desiredNumberPos.x = 'left';
				desiredNumberPos.y = 'top';
			}
		}


		if (isNeededNextIteration && placeTooltipIterations < 2) {
			if (this.options.dpDebugEn && placeTooltipIterations > 0) console.log('fullIterations', placeTooltipIterations);
			this.placeTooltip(targetItem, ++placeTooltipIterations, isCrowdedPos);
		}
		else {
			if (this.options.showStepNumbers) {
				let scrollToPos = this._getScrollOffset(targetItem, true);
				const scrollToPosNotNull = {
					x: scrollToPos.x !== null ? scrollToPos.x : $(window).scrollLeft(),
					y: scrollToPos.y !== null ? scrollToPos.y : $(window).scrollTop(),
				};
				//const scrollToPosNotNull = scrollToPos ? scrollToPos : { x: $(window).scrollLeft(), y: $(window).scrollTop() };
				this._placeNumberLayer(this.targetBB, scrollToPosNotNull, this.tooltipPos, desiredNumberPos);
			}

		}
	}

	actualizeNumberBB() {
		if (this.numberLayer) {
			//const numberOutlineSize = getCssValFloat(this.numberLayer, 'outline-width', 2);
			this.numberLayerBB = DPBoundingBox.getElBoundingBox(this.numberLayer, false, this.currentTargetItem?.isFixedPos);
		}
	}

	_placeNumberLayer = (targetBB, scrollToPos, tooltipPos, desiredPosition = { x: 'right', y: 'top', onTooltip: false }) => {
		this.dpIntroWrapper.style.setProperty('--num-size-coef', '');
		$(this.numberLayer).removeClass(LAYER_CLASSES.gelatinePulse);
		$(this.numberLayer).removeClass(LAYER_CLASSES.hidden + ' dpit-fixed');
		$(this.numberLayer).css('width', '');
		$(this.numberLayer).css('height', '');
		if (desiredPosition.onTooltip) {
			$(this.numberLayer).addClass(LAYER_CLASSES.numberOnTooltip);
			$(this.tooltipLayer).addClass(LAYER_CLASSES.tooltipWithNumber);
		}
		else {
			$(this.numberLayer).removeClass(LAYER_CLASSES.numberOnTooltip);
			$(this.tooltipLayer).removeClass(LAYER_CLASSES.tooltipWithNumber);
		}


		this.actualizeNumberBB();

		const numberLayerHalfSize = { width: this.numberLayerBB.width / 2, height: this.numberLayerBB.height / 2 };

		let layerNumberDest = this.highlightLayer;
		let bbNumberDest = targetBB;
		let bbOther = this.tooltipBB;
		if (desiredPosition.onTooltip) {
			bbNumberDest = this.tooltipBB;
			bbOther = targetBB;
			layerNumberDest = this.tooltipLayer;
		}

		//adjust distance of number and target ... higher dist for small targets
		const numberSizeCoef = { x: numberLayerHalfSize.width / bbNumberDest.width, y: numberLayerHalfSize.height / bbNumberDest.height };
		let numberPosCoef = 1;
		const threshold = 0.25;
		let numberSizeCoefCssVar = 1;
		let disableIndentation = false;
		if (numberSizeCoef.x > threshold || numberSizeCoef.y > threshold) {
			disableIndentation = true;
			const numberPosFeatures = { x: 1 - (numberSizeCoef.x - threshold), y: 1 - (numberSizeCoef.y - threshold) };
			numberPosCoef = Math.min(numberPosFeatures.x, numberPosFeatures.y);
			if (this.options.dpDebugEn) console.log('Adjusting number pos because small ref/tooltip. Coef: ', numberPosCoef, 'Features: ', numberPosFeatures);
			numberSizeCoefCssVar = Math.min(Math.max(1.7 * numberPosCoef, 0.8), 1);
			this.dpIntroWrapper.style.setProperty('--num-size-coef', numberSizeCoefCssVar);
			this.actualizeNumberBB();
		}

		const layerNumberDestRadius = getCssValFloat(layerNumberDest, 'border-top-left-radius', 2);
		const indention = layerNumberDestRadius + numberLayerHalfSize.width / 3;

		const possiblePositionsLT = {
			left: bbNumberDest.left - this.numberLayerBB.width + numberPosCoef * numberLayerHalfSize.width,
			right: bbNumberDest.right - 1 - numberPosCoef * numberLayerHalfSize.width,
			top: bbNumberDest.top - this.numberLayerBB.height + numberPosCoef * numberLayerHalfSize.height,
			bottom: bbNumberDest.bottom - 1 - numberPosCoef * numberLayerHalfSize.height,

			leftIndented: bbNumberDest.left + indention,
			rightIndented: bbNumberDest.right - 1 - this.numberLayerBB.width - indention,
			topIndented: bbNumberDest.top + indention,
			bottomIndented: bbNumberDest.bottom - 1 - this.numberLayerBB.height - indention,
		};

		let isInWindow = {
			left: possiblePositionsLT.left >= scrollToPos.x && possiblePositionsLT.left >= this.winBB.left,
			right: possiblePositionsLT.right + this.numberLayerBB.width <= scrollToPos.x + this.winBB.width - 1 && (possiblePositionsLT.right + this.numberLayerBB.width) <= this.docBB.right,
			top: possiblePositionsLT.top >= scrollToPos.y && possiblePositionsLT.top >= this.winBB.top,
			bottom: possiblePositionsLT.bottom + this.numberLayerBB.height <= scrollToPos.y + this.winBB.height - 1 && (possiblePositionsLT.bottom + this.numberLayerBB.height) <= this.docBB.bottom,
		};

		isInWindow = {
			...isInWindow,
			leftIndented: !disableIndentation && possiblePositionsLT.leftIndented <= bbNumberDest.right - indention
				&& possiblePositionsLT.leftIndented >= scrollToPos.x && possiblePositionsLT.leftIndented >= this.winBB.left,
			rightIndented: !disableIndentation && possiblePositionsLT.rightIndented + this.numberLayerBB.width >= bbNumberDest.left + indention
				&& possiblePositionsLT.rightIndented + this.numberLayerBB.width <= scrollToPos.x + this.winBB.width - 1 && possiblePositionsLT.rightIndented <= this.docBB.right,
			topIndented: !disableIndentation && possiblePositionsLT.topIndented <= bbNumberDest.bottom - indention
				&& possiblePositionsLT.topIndented >= scrollToPos.y && possiblePositionsLT.topIndented >= this.winBB.top,
			bottomIndented: !disableIndentation && possiblePositionsLT.bottomIndented + this.numberLayerBB.height >= bbNumberDest.top + indention
				&& possiblePositionsLT.bottomIndented + this.numberLayerBB.height <= scrollToPos.y + this.winBB.height - 1 && possiblePositionsLT.bottomIndented <= this.docBB.bottom,
		};

		const allowedPositionKeys = Object.keys(possiblePositionsLT).filter((position) => {
			return isInWindow[position];
		});



		let allowedPositionsTL = [];
		['top', 'topIndented', 'bottom', 'bottomIndented'].forEach((posY) => {
			if (allowedPositionKeys.includes(posY)) {
				['left', 'leftIndented', 'right', 'rightIndented'].forEach((posX) => {
					if (allowedPositionKeys.includes(posX)) {
						{
							let score = 0;
							const numberPositionType = { x: posX, y: posY };
							const isNumberCloseToTooltip = this.isNumberCloseToTooltip(numberPositionType, tooltipPos.base, desiredPosition.onTooltip);

							if (!desiredPosition.onTooltip) {
								if (desiredPosition.x === posX) score++;
								if (desiredPosition.y === posY) score++;
							}
							if (posX.endsWith('Indented')) score--;
							if (posY.endsWith('Indented')) score--;
							if (isNumberCloseToTooltip) score--;

							allowedPositionsTL.push({
								type: numberPositionType,
								left: possiblePositionsLT[posX],
								top: possiblePositionsLT[posY],
								score: score,
								isNumberCloseToTooltip: isNumberCloseToTooltip
							});
						}
					}
				});
			}
		});

		allowedPositionsTL.sort((a, b) => {
			return b.score - a.score;
		});


		let finalPositions = [];
		if (tooltipPos.base !== 'center') {
			allowedPositionsTL.forEach(posTL => {
				const posBB = DPBoundingBox.actualizeBottomAndRight({ ...posTL, width: this.numberLayerBB.width, height: this.numberLayerBB.height });
				const intersection = DPBoundingBox.intersect(bbOther, posBB);
				if (!intersection) {
					finalPositions.push({ ...posTL });
				}
			});
		}
		else {
			finalPositions = allowedPositionsTL;
		}



		if (finalPositions.length) {

			if (this.currentTargetItem?.isFixedPos && desiredPosition.onTooltip) {
				finalPositions[0].top += $(window).scrollTop();
				finalPositions[0].left += $(window).scrollLeft();
			}

			if (numberSizeCoefCssVar >= 1 && finalPositions[0].isNumberCloseToTooltip) {
				numberSizeCoefCssVar = 0.95;
				if (this.options.dpDebugEn) console.log('Number is close to tooltip');
				this.dpIntroWrapper.style.setProperty('--num-size-coef', numberSizeCoefCssVar);
			}

			if (desiredPosition.onTooltip) {
				$(this.numberLayer).addClass(LAYER_CLASSES.numberOnTooltip);
				$(this.tooltipLayer).addClass(LAYER_CLASSES.tooltipWithNumber);
				if (this.isStickyTheme()) {
					this._placeNumberLayerOnTooltipInFixedBottomTheme(numberLayerHalfSize);
					return;
				}
			}

			$(this.numberLayer).offset({ top: finalPositions[0].top, left: finalPositions[0].left });
		}
		else if (!desiredPosition.onTooltip) {
			if (!this.isStickyTheme()) this._placeNumberLayer(targetBB, scrollToPos, tooltipPos, { ...desiredPosition, onTooltip: true });
			else this._placeNumberLayerOnTooltipInFixedBottomTheme(numberLayerHalfSize);
		}
		else {
			$(this.numberLayer).addClass(LAYER_CLASSES.hidden);
		}
	}

	_placeNumberLayerOnTooltipInFixedBottomTheme(numberLayerHalfSize) {
		$(this.numberLayer).addClass(LAYER_CLASSES.numberOnTooltip);
		$(this.tooltipLayer).addClass(LAYER_CLASSES.tooltipWithNumber);
		$(this.numberLayer).css({
			top: ($(this.tooltipLayer).position()?.top
				+ $(this.tooltipTextLayer).position()?.top
				+ getCssValFloat(this.tooltipTextLayer, 'padding-top', '5')) + 'px',
			left: (0.5 * numberLayerHalfSize.width) + 'px'
		});
	}

	isNumberCloseToTooltip(numberPositionType, tooltipPosBase, isOnTooltip) {
		if (!this.isStickyTheme()) {
			const _tooltipPosBase = isOnTooltip ? getReverseBasePos(tooltipPosBase) : tooltipPosBase;
			if (_tooltipPosBase === numberPositionType.x) {
				if (isOnTooltip) {
					if (this.tooltipBB.top + this.numberLayerBB.height > this.targetBB.top) return true;
					else if (this.tooltipBB.bottom - this.numberLayerBB.height < this.targetBB.bottom) return true;
				}
				else {
					if (this.tooltipBB.top - this.numberLayerBB.height < this.targetBB.top) return true;
					else if (this.tooltipBB.bottom + this.numberLayerBB.height > this.targetBB.bottom) return true;
				}
			}
			else if (_tooltipPosBase === numberPositionType.y) {
				if (isOnTooltip) {
					if (this.tooltipBB.left + this.numberLayerBB.width > this.targetBB.left) return true;
					else if (this.tooltipBB.right - this.numberLayerBB.width < this.targetBB.right) return true;
				}
				else {
					if (this.tooltipBB.left - this.numberLayerBB.width < this.targetBB.left) return true;
					else if (this.tooltipBB.right + this.numberLayerBB.width > this.targetBB.right) return true;
				}
			}
		}
		return false;
	}

	adjustFixedPositionsOutOfWindow(targetItem) {
		// check fixed positions out of window
		if (targetItem?.isFixedPos) {
			if (this.tooltipBB.bottom > this.maxScreenArea.bottom) {
				const maxHeightBkp = this.tooltipTextLayer.style.maxHeight;
				const tooltipTextHeight = $(this.tooltipTextLayer).height();
				const textLayerMaxHeight = Math.max(tooltipTextHeight - (this.tooltipBB.bottom - this.maxScreenArea.bottom), 50);
				this.tooltipTextLayer.style.maxHeight = textLayerMaxHeight + 'px';
				this.tooltipBB = DPBoundingBox.getElBoundingBox(this.tooltipLayer, false, targetItem?.isFixedPos);
				const isCrowdedPos = this.tooltipBB.bottom > this.maxScreenArea.bottom;
				if (isCrowdedPos) this.tooltipTextLayer.style.maxHeight = maxHeightBkp;
				return isCrowdedPos;
			} else if (this.tooltipBB.top < this.maxScreenArea.top) {
				const maxHeightBkp = this.tooltipTextLayer.style.maxHeight;
				const topOffsetBkp = $(this.tooltipLayer).offset().top;
				const tooltipTextHeight = $(this.tooltipTextLayer).height();
				const textLayerMaxHeight = Math.max(tooltipTextHeight - (this.maxScreenArea.top - this.tooltipBB.top), 50);
				this.tooltipTextLayer.style.maxHeight = textLayerMaxHeight + 'px';
				$(this.tooltipLayer).offset({ top: $(this.tooltipLayer).offset().top + tooltipTextHeight - textLayerMaxHeight });
				this.tooltipBB = DPBoundingBox.getElBoundingBox(this.tooltipLayer, false, targetItem?.isFixedPos);
				const isCrowdedPos = this.tooltipBB.top < this.maxScreenArea.top;
				if (isCrowdedPos) {
					this.tooltipTextLayer.style.maxHeight = maxHeightBkp;
					$(this.tooltipLayer).offset({ top: topOffsetBkp });
				}
				return isCrowdedPos;
			}
		}
		return false;
	}

	getMinimalTooltipWidth() {
		const minWidth = $(this.buttonSkipLayer).outerWidth()
			+ $(this.buttonPrevLayer).outerWidth()
			+ $(this.buttonNextLayer).outerWidth()
			+ getCssValFloat(this.tooltipLayer, 'padding-left', 20) * 2 + 20;
		return isNaN(minWidth) ? 300 /* Default 300px*/ : minWidth;
	}

	/**
	 * Determines the position of the tooltip based on the position precedence and availability
	 * of screen space.
	 *
	 */
	_determineAutoPosition = (targetItem, arrowSizes, isCrowdedPos) => {
		let calculatedPosition = { base: 'bottom', align: 'middle', width: this.tooltipBB.width };
		let desiredTooltipPosition = targetItem.position;
		if (targetItem.isDummyElement) {
			calculatedPosition.base = 'center';
			if (this.winBB.width < 600) calculatedPosition.align = 'top';
			else calculatedPosition.align = 'middle';
			return calculatedPosition;
		}

		if (isCrowdedPos[desiredTooltipPosition]) {
			desiredTooltipPosition = getReverseBasePos(desiredTooltipPosition);
		}

		const possiblePositionsScoreInc = {};
		this.options.positionPrecedence.forEach((position) => {
			possiblePositionsScoreInc[position] = {
				score: 0,
				disabled: false
			};
		});

		let tooltipSizesArrowInc = {
			width: this.tooltipBB.width + arrowSizes.width / 2 + this.options.tooltipDistanceFromTarget,
			height: this.tooltipBB.height + arrowSizes.height / 2 + this.options.tooltipDistanceFromTarget
		};

		const minimalTooltipWidth = this.getMinimalTooltipWidth();
		let newTooltipWidthArrowInc = {
			left: tooltipSizesArrowInc.width,
			right: tooltipSizesArrowInc.width
		};
		let newTooltipWidth = {
			left: null,
			right: null
		};

		const rightWidthArrowInc = this.maxDocBoardBB.right - this.targetBB.right;
		const rightWidth = rightWidthArrowInc - arrowSizes.width / 2 - this.options.tooltipDistanceFromTarget;
		if (rightWidth > minimalTooltipWidth && rightWidth < this.tooltipBB.width) {
			newTooltipWidthArrowInc.right = rightWidthArrowInc;
			newTooltipWidth.right = rightWidth;
		}

		const leftWidthArrowInc = this.targetBB.left - this.maxDocBoardBB.left;
		const leftWidth = leftWidthArrowInc - arrowSizes.width / 2 - this.options.tooltipDistanceFromTarget;
		if (leftWidth > minimalTooltipWidth && leftWidth < this.tooltipBB.width) {
			newTooltipWidthArrowInc.left = leftWidthArrowInc;
			newTooltipWidth.left = leftWidth;
		}

		const minTargetCenterHeigh = (desiredTooltipPosition === 'center') ? this.targetBB.height : this.targetBB.height / 2;
		const targetWithTooltipHeightTopBottom = tooltipSizesArrowInc.height + this.targetBB.height;
		const heightScoreTopBottom = (this.winBB.height - targetWithTooltipHeightTopBottom) / this.winBB.height;


		// Check for space below
		possiblePositionsScoreInc['bottom'].disabled = (this.targetBB.bottom + tooltipSizesArrowInc.height > this.maxDocBoardBB.bottom && !targetItem?.isFixedPos);
		possiblePositionsScoreInc['bottom'].score += (isCrowdedPos.bottom ? -1 : heightScoreTopBottom);


		// Check for space above
		possiblePositionsScoreInc['top'].disabled = (this.targetBB.top - tooltipSizesArrowInc.height < this.maxDocBoardBB.top && !targetItem?.isFixedPos);
		possiblePositionsScoreInc['top'].score += (isCrowdedPos.top ? -1 : heightScoreTopBottom);

		// Check for space to the right
		possiblePositionsScoreInc['right'].disabled = (this.targetBB.right + newTooltipWidthArrowInc.right > this.maxDocBoardBB.right + 1); // +1 i don't know why yet
		possiblePositionsScoreInc['right'].score += (isCrowdedPos.right ? -1 : 1 - (newTooltipWidthArrowInc.right / (this.winBB.width - this.targetBB.right)));

		// Check for space to the left
		possiblePositionsScoreInc['left'].disabled = (this.targetBB.left - newTooltipWidthArrowInc.left < this.maxDocBoardBB.left);
		possiblePositionsScoreInc['left'].score += (isCrowdedPos.left ? -1 : 1 - (newTooltipWidthArrowInc.left / this.targetBB.left));

		// Check for space inside
		possiblePositionsScoreInc['center'].disabled = this.targetBB.width <= this.tooltipBB.width || minTargetCenterHeigh <= this.tooltipBB.height;
		if (this.targetBB.width - this.tooltipBB.width < this.targetBB.height - this.tooltipBB.height) {
			possiblePositionsScoreInc['center'].score += (this.targetBB.width - this.tooltipBB.width) / this.targetBB.width - 0.5;
		}
		else {
			possiblePositionsScoreInc['center'].score += (this.targetBB.height - this.tooltipBB.height) / this.targetBB.height - 0.5;
		}

		const possiblePositionsScoreIncArr = [];
		Object.keys(possiblePositionsScoreInc).forEach((pos) => {
			if (!possiblePositionsScoreInc[pos].disabled) {
				possiblePositionsScoreIncArr.push({
					position: pos,
					score: possiblePositionsScoreInc[pos].score
				});
			}
		});
		possiblePositionsScoreIncArr.sort((a, b) => {
			return b.score - a.score;
		});
		//if (this.options.dpDebugEn) console.log(possiblePositionsScoreIncArr);

		const possiblePositions = possiblePositionsScoreIncArr.map((val) => {
			return val.position;
		});
		//if (this.options.dpDebugEn) console.log(possiblePositions);

		// @var {String}  ex: 'right-aligned'
		var desiredAlignment = (function (pos) {
			var hyphenIndex = pos.indexOf('-');
			if (hyphenIndex !== -1) {
				// has alignment
				return pos.substr(hyphenIndex);
			}
			return '';
		})(desiredTooltipPosition || '');

		// strip alignment from position
		if (desiredTooltipPosition) {
			// ex: "bottom-right-aligned"
			// should return 'bottom'
			desiredTooltipPosition = desiredTooltipPosition.split('-')[0];
		}



		if (possiblePositions.length) {
			if (desiredTooltipPosition !== 'auto' &&
				possiblePositions.indexOf(desiredTooltipPosition) > -1) {
				// If the requested position is in the list, choose that
				calculatedPosition.base = desiredTooltipPosition;
			} else {
				// Pick the first valid position, in order
				calculatedPosition.base = possiblePositions[0];
			}
		}
		else {
			//$(this.tooltipTextLayer).addClass(LAYER_CLASSES.tooltipText + '--compact');
			// smaller font

		}


		// top and bottom alignments
		if (['top', 'bottom'].indexOf(calculatedPosition.base) !== -1) {
			calculatedPosition.align = this._determineAutoAlignmentX(this.targetBB, tooltipSizesArrowInc.width, desiredAlignment);
		}
		//  left and right positions alignments
		else if (['left', 'right'].indexOf(calculatedPosition.base) !== -1) {
			if (newTooltipWidth[calculatedPosition.base]) calculatedPosition.width = newTooltipWidth[calculatedPosition.base];


			calculatedPosition.align = this._determineAutoAlignmentY(this.targetBB, tooltipSizesArrowInc.height, desiredAlignment, arrowSizes);

		}
		else if (calculatedPosition.base === 'center') {
			calculatedPosition.align = 'middle';
		}

		//if (this.options.dpDebugEn) console.log(calculatedPosition);

		return calculatedPosition;
	}

	/**
	* auto-determine alignment
	* @param {Integer}  offsetLeft
	* @param {Integer}  tooltipWidth
	* @param {String}   desiredAlignment
	* @return {String}  calculatedAlignment
	*/
	_determineAutoAlignmentX = (targetBB, tooltipWidth, desiredAlignment) => {

		const possibleAlignments = ['center', 'left', 'right'];
		let calculatedAlignment = '';

		if (targetBB.left + tooltipWidth > this.maxDocBoardBB.right) {
			this._removeEntry(possibleAlignments, 'left');
		}

		const targetCenterX = targetBB.left + targetBB.width / 2;
		if (targetCenterX - 0.5 * tooltipWidth < this.maxDocBoardBB.left ||
			targetCenterX + 0.5 * tooltipWidth > this.maxDocBoardBB.right) {
			this._removeEntry(possibleAlignments, 'center');
		}

		if (targetBB.right - tooltipWidth < this.maxDocBoardBB.left) {
			this._removeEntry(possibleAlignments, 'right');
		}

		if (possibleAlignments.length) {
			if (possibleAlignments.indexOf(desiredAlignment) !== -1) {
				// the desired alignment is valid
				calculatedAlignment = desiredAlignment;
			} else {
				// pick the first valid position, in order
				calculatedAlignment = possibleAlignments[0];
			}
		} else {
			// if screen width is too small 
			// for ANY alignment, middle is 
			// probably the best for visibility
			calculatedAlignment = 'center';
		}

		return calculatedAlignment;
	}

	/**
	* auto-determine alignment
	* @param {Integer}  offsetLeft
	* @param {Integer}  tooltipHeight
	* @param {Object}   windowSize
	* @param {String}   desiredAlignment
	* @return {String}  calculatedAlignment
	*/
	_determineAutoAlignmentY = (targetBB, tooltipHeight, desiredAlignment) => {


		const possibleAlignments = ['middle', 'top', 'bottom'];
		let calculatedAlignment = '';

		if (targetBB.top + tooltipHeight > this.maxDocBoardBB.bottom) {
			this._removeEntry(possibleAlignments, 'top');
		}

		const targetCenterY = targetBB.top + targetBB.height / 2;
		if (targetCenterY - tooltipHeight / 2 < this.maxDocBoardBB.top ||
			targetCenterY + tooltipHeight / 2 > this.maxDocBoardBB.bottom) {
			this._removeEntry(possibleAlignments, 'middle');
		}

		if (targetBB.bottom - tooltipHeight < this.maxDocBoardBB.top) {
			this._removeEntry(possibleAlignments, 'bottom');
		}

		if (possibleAlignments.length) {
			if (possibleAlignments.indexOf(desiredAlignment) !== -1) {
				// the desired alignment is valid
				calculatedAlignment = desiredAlignment;
			} else {
				// pick the first valid position, in order
				calculatedAlignment = possibleAlignments[0];
			}
		}
		else {
			// if screen width is too small 
			// for ANY alignment, middle is 
			// probably the best for visibility
			calculatedAlignment = 'middle';
		}

		return calculatedAlignment;
	}

	/**
	 * Remove an entry from a string array if it's there, does nothing if it isn't there.
	 *
	 * @param {Array} stringArray
	 * @param {String} stringToRemove
	 */
	_removeEntry = (stringArray, stringToRemove) => {
		if (stringArray.indexOf(stringToRemove) > -1) {
			stringArray.splice(stringArray.indexOf(stringToRemove), 1);
		}
	}

	/**
	 * Update the position of the helper layer on the screen
	 *
	 * @api private
	 * @method _setHelperLayerPosition
	 * @param {Object} layer
	 */
	setLayerPosition = (layer, addClass = null, remClass = null, fixRadiuses = false) => {
		if (layer) {
			//prevent error when `this._currentStep` in undefined
			if (!this.currentTargetItem) return;

			if (fixRadiuses) {
				$(layer).removeClass('dpit-no-lradius dpit-no-rradius');
				if (this.targetBB.left <= 0) {
					$(layer).addClass('dpit-no-lradius');
				}
				if (this.targetBB.right >= this.docBB.width) {
					$(layer).addClass('dpit-no-rradius');
				}
			}

			if (addClass) $(layer).addClass(addClass);
			if (remClass) $(layer).removeClass(remClass);

			if (this.currentTargetItem.isFixedPos) {
				$(layer).addClass('dpit-fixed');
			} else {
				$(layer).removeClass('dpit-fixed');
			}

			if (this.currentTargetItem.isFixedPos) {
				$(layer).css({
					top: this.targetBB.top + 'px',
					left: this.targetBB.left + 'px',
					width: this.targetBB.width + 'px',
					height: this.targetBB.height + 'px'
				});
			}
			else {
				$(layer).offset({
					top: this.targetBB.top,
					left: this.targetBB.left
				});

				$(layer).css({
					width: this.targetBB.width + 'px',
					height: this.targetBB.height + 'px'
				});
			}
		}
	}

	/**
	 * Add disableinteraction layer and adjust the size and position of the layer
	 *
	 * @api private
	 * @method _disableInteraction
	 */
	_disableInteraction() {
		if (!this.disableInteractionLayer) {
			this.disableInteractionLayer = document.createElement('div');
			this.disableInteractionLayer.className = LAYER_CLASSES.disableInteraction;
			this.mainElement.appendChild(this.disableInteractionLayer);
		}
		this.updateIterateAfter(this.currentTargetItem);
		this.setLayerPosition(this.disableInteractionLayer);
	}

	_enableInteraction(clearIterateAfterClickOnly = false) {
		//remove disableInteractionLayer
		if (this.disableInteractionLayer) {
			this.disableInteractionLayer.parentNode.removeChild(this.disableInteractionLayer);
			this.disableInteractionLayer = null;
		}
		this.updateIterateAfter(this.currentTargetItem, clearIterateAfterClickOnly);

	}

	_isInteractionEnabled() {
		return !this.disableInteractionLayer;
	}

	/**
	 * Setting anchors to behave like buttons
	 *
	 * @api private
	 * @method _setAsButton
	 */
	_setAsButton = (anchor, label, tabIndex = 0) => {
		anchor.setAttribute('role', 'button');
		if (label && typeof label === 'string') anchor.setAttribute('aria-label', label);
		if (tabIndex >= 0) {
			anchor.tabIndex = 0;
		}
	}

	actualizeTargetItem = (targetItem, backward, isRegularStepChange = true) => {
		if (this.actualizeTargetItemCore(targetItem, isRegularStepChange)) {
			// skipping step
			if (!backward) {
				if (this._currentStep < this.introItems.length - 1) {
					if (this._currentStep === 0) this.visibleFirstStepShouldBeEvaluated = true;
					this.goToNextStep();
				}
				else {
					this.visibleLastStepShouldBeEvaluated = true;
					this.goToPreviousStep();
				}
			}
			else {
				if (!this.goToPreviousStep()) {
					this.visibleFirstStepShouldBeEvaluated = true;
					this.goToNextStep();
				}
			}
			return false;
		}

		if (this.visibleLastStepShouldBeEvaluated) {
			this.visibleLastStep = this._currentStep;
			this.visibleLastStepShouldBeEvaluated = false;
		}
		if (this.visibleFirstStepShouldBeEvaluated) {
			this.visibleFirstStep = this._currentStep;
			this.visibleFirstStepShouldBeEvaluated = false;
		}
		return true;
	}

	isStepItemInMobileMenu(stepItem) {
		return stepItem.is_mobile_menu_active_element && stepItem.alt_mobile_selector;
	}

	actualizeTargetItemCore = (stepItem, isRegularStepChange = true, isInit = false) => {
		let skipStep = false;
		if (stepItem) {

			if (this.isStepItemInMobileMenu(stepItem)) {
				const mobMenuEl = $S(stepItem.alt_mobile_selector);
				if (mobMenuEl && mobMenuEl.length) {
					stepItem.element = mobMenuEl[0];
					this.resetStepAsDummy(stepItem);
					/*stepItem.isFixedPos = this.isFixedPos(stepItem.element);
					return;*/
				}

			}
			else if (stepItem.alt_mobile_selector && this.isMobileSize) {
				const el = $S(stepItem.alt_mobile_selector, null);
				if (el && el.length) stepItem.element = el[0];
				else stepItem.element = null;
			}
			else if (stepItem.selector) {
				const el = $S(stepItem.selector, null);
				if (el && el.length) stepItem.element = el[0];
				else stepItem.element = null;
			}
			else stepItem.element = null;

			if (isRegularStepChange) {
				skipStep = this._shouldBeStepSkipped(stepItem, this.isMobileSize);
				this.setNotVisibleRefBullet(stepItem.step, skipStep);
				this.updateIterateAfter(stepItem);
				if (this.options.dpDebugEn) console.log('Current step:', stepItem);
			}

			if (this.options.dpDebugEn && (!stepItem.element || !$(stepItem.element).is(':visible'))) {
				if (this.options.dpDebugEn && isRegularStepChange) console.log('Current not visible!');
			}

			const targetElementIsNotVisibleAndNotSkipped = stepItem.element && this.targetDummy !== stepItem.element && (!$(stepItem.element).is(':visible')) && (!isRegularStepChange || !this.options.skip_absent_ref_el);

			if (!skipStep) {
				if (!stepItem.element || this.targetDummy === stepItem.element || targetElementIsNotVisibleAndNotSkipped) {
					this.setStepAsDummy(stepItem, targetElementIsNotVisibleAndNotSkipped ? stepItem.element : null);
				}
				else {
					this.resetStepAsDummy(stepItem);
				}
			}

			if (!isInit) {
				if (this.hasTargetItemHiddenOverlay(stepItem)) {
					this.hideOverlay();
				}
				else {
					this.showOverlay();
				}
			}

			stepItem.isFixedPos = this.isFixedPos(stepItem.element);
		}
		return skipStep;
	}

	hasTargetItemHiddenOverlay(item) {
		if (item) {
			return item
				&& item.element
				&& item.enable_interaction.val == '1'
				&& !item.isDummyElement
				&& item.enable_interaction.ext?.hide_overlay == '1';
		}
		return false;
	}

	updateIterateAfter(stepItem, clearOnly = false) {
		this.updateIterateAfterClick(stepItem, clearOnly);
		this.updateIterateAfterHover(stepItem, clearOnly);

	}

	updateIterateAfterClick(stepItem, clearOnly = false) {

		if (stepItem && stepItem.element) {
			$(stepItem.element).off('mousedown', this.iterateStepAfterUserAction);
			$(stepItem.element).off('mousedown', this.stopClickPropagation);
			$(stepItem.element).off('click', this.stopClickPropagation);
			$(stepItem.element).off('mouseup', this.stopClickPropagation);
			$(stepItem.element).removeClass(LAYER_CLASSES.targetClick);
			$(stepItem.element).removeClass(LAYER_CLASSES.targetBlockEvents);
		}
		if (!clearOnly) {
			if (this.isIterateAfterClick(stepItem)) {
				$(stepItem.element).on('mousedown', this.iterateStepAfterUserAction);
				$(stepItem.element).addClass(LAYER_CLASSES.targetClick);
			}
			if (this.isStopClickPropagation(stepItem)) {
				$(stepItem.element).on('mousedown', this.stopClickPropagation);
				$(stepItem.element).on('click', this.stopClickPropagation);
				$(stepItem.element).on('mouseup', this.stopClickPropagation);
			}
		}
	}

	stopClickPropagation = (event) => {
		if (event) {
			if (event.target) {
				if (event.type === 'mousedown') {
					$(event.target).closest(LAYER_CLASSES.target).addClass(LAYER_CLASSES.targetBlockEvents);
				}
				if (event.type === 'mouseup') {
					$(event.target).closest(LAYER_CLASSES.target).removeClass(LAYER_CLASSES.targetBlockEvents);
				}
			}
			event.stopImmediatePropagation();
			event.preventDefault();
		}
		return false;
	}

	iterateStepAfterUserAction = () => {

		if (!this.options.disableIterateAfterActions && this.currentTargetItem) {
			let delay = this.currentTargetItem.enable_interaction?.ext?.iterate_after_click_delay_ms ?? 500;
			//this.reInitTarget();
			this.inHighlightLayerAnimation.createAndRun();

			hideElement(this.currentTargetItem?.element);

			setTimeout(() => {
				this.inHighlightLayerAnimation.destroy();
				showElement(this.currentTargetItem?.element);
				this.goToNextStep();
			}, delay);
		}
		return true;
	}

	isIterateAfterClick(stepData) {
		return stepData
			&& stepData.element
			&& stepData.enable_interaction.val == '1'
			&& !stepData.isDummyElement
			&& stepData.enable_interaction.ext?.iterate_after_click == '1';
	}



	isStopClickPropagation(stepData) {
		return stepData
			&& stepData.element
			&& stepData.enable_interaction.val == '1'
			&& !stepData.isDummyElement
			&& stepData.enable_interaction.ext?.iterate_after_click_stop_propagation == '1';
	}

	updateIterateAfterHover(stepItem, clearOnly = false) {
		if (stepItem && stepItem.element) $(stepItem.element).off('mouseenter', this.iterateStepAfterUserAction).removeClass('dpit-target--hover');
		if (!clearOnly && this.isIterateAfterHover(stepItem)) $(stepItem.element).on('mouseenter', this.iterateStepAfterUserAction).addClass('dpit-target--hover');
	}

	isIterateAfterHover(stepData) {
		return stepData
			&& stepData.element
			&& stepData.enable_interaction.val == '1'
			&& !stepData.isDummyElement
			&& stepData.enable_interaction.ext?.iterate_after_hover == '1';
	}

	isHideNextByCurrentStepMeta() {
		return this.currentTargetItem
			&& this.currentTargetItem.element
			&& this.currentTargetItem.enable_interaction.val == '1'
			&& !this.currentTargetItem.isDummyElement
			&& this.currentTargetItem.enable_interaction.ext?.hide_next_btn == '1';
	}

	getIsMobileSize(breakPointOverride = null) {
		return this.options.mobileBreakpoints && (this.winBB.width <= (breakPointOverride ? breakPointOverride : this.options.mobileBreakpoints.mobile));
	}

	_shouldBeStepSkipped(stepItem, isMobileSize) {
		let skipStep = false;
		if (this.options.skip_absent_ref_el
			&& (stepItem.selector || (isMobileSize && stepItem.alt_mobile_selector))
			&& (!stepItem.element || !$(stepItem.element).is(':visible') || !this.isElementInsideDocBoard(stepItem.element))
		) {
			skipStep = true;
		}
		return skipStep;

	}

	isElementInsideDocBoard(element) {
		if (this.docBB && element) {
			const bb = DPBoundingBox.getElBoundingBox(element, false, false);
			return DPBoundingBox.intersect(bb, this.docBB) !== null;
		}
		return true;
	}

	isElementInsideMaxScreenArea(element, relativeToCurrentScrollTop = true) {
		if (this.maxScreenArea && element) {
			const bb = DPBoundingBox.getElBoundingBox(element, false, relativeToCurrentScrollTop);
			return DPBoundingBox.intersect(bb, this.maxScreenArea) !== null;
		}
		return true;
	}

	_isElementHidden(el) {
		return (el.offsetParent === null);
	}

	getHighlightLayerClass(targetItem) {
		return classNames({
			[LAYER_CLASSES.highlight]: true,
			[targetItem?.highlightClass]: targetItem && typeof (targetItem.highlightClass) === 'string' && targetItem.highlightClass,
			[this.options.highlightClass]: typeof (this.options.highlightClass) === 'string' && this.options.highlightClass
		});
	}

	reInitLayers(hideOverlay = false, targetItem = null) {

		const highlightLayerClass = this.getHighlightLayerClass(targetItem);
		if (!this.highlightLayer) {
			// Check if layers was created
			this.initLayers(highlightLayerClass);
			this.actualizeBoardSizes();
		} else {
			this.highlightLayer.className = highlightLayerClass;
		}

		$(this.tooltipTextLayer).removeClass(LAYER_CLASSES.tooltipText + '--compact');

		// Init
		if (targetItem) {
			this.mainElement.setAttribute('id', 'dpit-step-' + targetItem.step);
			this.tooltipLayer.setAttribute('id', 'dpit-tooltip-step-' + targetItem.step);
			this.highlightLayer.setAttribute('id', `${LAYER_CLASSES.highlight}-step-${targetItem.step}`);
			if (targetItem.isDummyElement) $(this.highlightLayer).addClass('highlight-dummy');
		}

		// Hide
		if (!IS_DEBUG) this.hideIntroLayers(hideOverlay);



		$(this.numberLayer).removeClass(LAYER_CLASSES.numberOnTooltip);
		$(this.tooltipLayer).removeClass(LAYER_CLASSES.tooltipWithNumber);

	}

	actualizeUserInteraction(targetItem) {
		//disable interaction
		if (targetItem && targetItem.enable_interaction.val != '1' && !targetItem.isDummyElement) {
			this._disableInteraction();
		} else {
			this._enableInteraction();
		}

	}

	getStartStepIdx() {
		if (this.visibleFirstStep) return this.visibleFirstStep;
		return 0;
	}

	getEndStepIdx() {
		if (this.visibleLastStep) return this.visibleLastStep;
		return this.introItems.length - 1;
	}

	setTooltipContent(targetItem) {
		this.tooltipTextLayer.innerHTML = targetItem ? targetItem.intro_proc || targetItem.intro : '';
		this.checkTooltipIFrames(this.tooltipTextLayer.innerHTML);
	}

	checkTooltipIFrames = (innerHTML) => {
		this.tooltipBBRel = DPBoundingBox.getElBoundingBox(this.tooltipTextLayer, false, true);
		if (innerHTML) {
			const start = innerHTML.indexOf('<iframe');
			if (start >= 0) {
				const stop = innerHTML.indexOf('>', start + 7);
				if (stop >= 0) {
					const iframeStr = innerHTML.substr(start, stop - start + 1);
					if (iframeStr && iframeStr.includes('allowfullscreen')) {
						this._isIframeInTooltip = true;
						return;

					}
				}
			}
		}
		this._isIframeInTooltip = false;
	}


	actualizeAutoFocus = (isRefresh) => {
		if (this.options.controlsAutoFocusEnable && !isRefresh) {
			let control = null;
			switch (this.activeControl) {
				case 'next': control = this.buttonNextLayer; break;
				case 'back': control = this.buttonPrevLayer; break;
				case 'skip': control = this.buttonSkipLayer; break;
			}

			if (this.options.dpDebugEn) console.log('Active control: ' + this.activeControl);
			if (control) {
				control.focus({ preventScroll: true, focusVisible: false });
			}
		}
	}

	actualizeProgressBar = () => {
		if (this.options.showProgress !== true) {
			this.progressLayer.style.display = 'none';
		}
		else {
			this.progressLayer.style.display = '';
		}
		const progressVal = this.getProgressInPercent();
		this.progressBarLayer.style.cssText = 'width:' + progressVal + '%;';
		this.progressBarLayer.setAttribute('aria-valuenow', progressVal);
	}


	actualizeBulletsNavig = (targetItem) => {
		$(this.bulletsLayer).find('.' + LAYER_CLASSES.bulletPulse).removeClass(LAYER_CLASSES.bulletPulse);
		// Adjusting bullets - skipped steps
		if (this.visibleLastStep) {
			for (let i = this.visibleLastStep + 1; i < this.introItems.length; i++) {
				this.setNotVisibleRefBullet(i + 1, true);
			}
		}
		if (this.visibleFirstStep) {
			for (let i = this.visibleFirstStep - 1; i >= 0; i--) {
				this.setNotVisibleRefBullet(i + 1, true);
			}
		}

		//change active bullet
		if (this.options.showBullets) {
			this.activateBullet(targetItem.step);
		}

		this.actualizeBulletScrollBar();

	}

	actualizeStickyBullets() {
		const isStickyTheme = this.isStickyTheme();
		$(this.bulletsLayer).removeClass(`${LAYER_CLASSES.bullets}--hidden`);
		if (isStickyTheme && this.bulletsLayer) {
			if (!this.currentTargetItem.isDummyElement) {
				const bulletsBB = DPBoundingBox.getElBoundingBox(this.bulletsLayer);
				if (DPBoundingBox.intersect(bulletsBB, this.currentFlyingObjectBB)) {
					$(this.bulletsLayer).addClass(`${LAYER_CLASSES.bullets}--hidden`);
				}
			}
		}
	}

	actualizeBulletScrollBar(autoScroll = false, backward = false) {
		let jBulletsListElement = $(this.bulletsLayer).children('ul');
		if (jBulletsListElement) {
			if ($(jBulletsListElement).hasScrollBar(true, false)) {
				$(jBulletsListElement).addClass('dpit-has-scrollbar');
				if (autoScroll) {
					const jActiveItem = jBulletsListElement.children('li.active');
					if (jActiveItem.length) {
						this.scrollParentToTarget(jActiveItem.get(0), true, true, false, true, backward);
					}
				}


			}
			else {
				$(jBulletsListElement).removeClass('dpit-has-scrollbar');
			}
		}
	}

	actualizeButtons() {

		// Buttons
		let isHideNextByCurrentStepMeta = this.isHideNextByCurrentStepMeta();
		const isLastStep = this.getEndStepIdx() <= this._currentStep;
		const isFirstStep = this._currentStep <= this.getStartStepIdx();

		if (isFirstStep && this.introItems.length > 1) this.activeControl = 'next';
		else if (isLastStep) this.activeControl = 'skip';

		//const hidePrev = this.options.hide_previous_step_button || (this.options.hidePrev && isFirstStep);
		//const hideNext = this.options.hideNextAlways || isHideNextByCurrentStepMeta || (this.options.hideNext === true && isLastStep);
		const buttonPrevClass = classNames({
			[this.options.buttonClass]: true,
			[LAYER_CLASSES.buttonPrev]: true,
			//[LAYER_CLASSES.hidden]: hidePrev,
			[LAYER_CLASSES.disabled]: isFirstStep,
			[LAYER_CLASSES.noTrans]: true,
		});
		const buttonNextClass = classNames({
			[this.options.buttonClass]: true,
			[LAYER_CLASSES.buttonNext]: true,
			//[LAYER_CLASSES.hidden]: hideNext,
			[LAYER_CLASSES.disabled]: isLastStep || isHideNextByCurrentStepMeta,
			[LAYER_CLASSES.noTrans]: true,
		});
		const buttonSkipClass = classNames({
			[this.options.buttonClass]: true,
			[LAYER_CLASSES.buttonSkip]: true,
			[LAYER_CLASSES.buttonDone]: isLastStep,
			[LAYER_CLASSES.noTrans]: true,
		});
		const buttonSkipLabel = isLastStep ? this.options.labeling.doneLabel : this.options.labeling.skipLabel;

		if (this.buttonPrevLayer) {
			this.buttonPrevLayer.className = buttonPrevClass;
		}

		if (this.buttonNextLayer) {
			this.buttonNextLayer.className = buttonNextClass;
		}

		if (typeof this.buttonSkipLayer !== 'undefined' && this.buttonSkipLayer !== null) {
			const isSticky = this.isStickyTheme();
			this.buttonSkipLayer.className = buttonSkipClass;
			this.buttonSkipLayer.setAttribute('title', isSticky && !isLastStep ? buttonSkipLabel : '');
			this.buttonSkipLayer.innerHTML = isSticky && !isLastStep ? '' : buttonSkipLabel;
		}

		if (this.options.disable_navigation_by_bullets) $(this.bulletsLayer).addClass(LAYER_CLASSES.bullets + '--pointer-events-none');
		else $(this.bulletsLayer).removeClass(LAYER_CLASSES.bullets + '--pointer-events-none');


		if (this.introItems.length > 1) {
			if (this.options.showBullets) {
				$(this.bulletsLayer).slideDown();
			}
			if (this.options.showProgress === true) {
				$(this.progressLayer).slideDown();
			}
		}
		else {
			$(this.bulletsLayer).slideUp();
			$(this.progressLayer).slideUp();
		}
		$(`.${LAYER_CLASSES.button}`).removeClass(LAYER_CLASSES.noTrans);


	}

	fixTargetLowContrast = (targetItem, isSecondTry = false) => {
		// check color of target element to ensure contrast background
		try {
			if (!targetItem || targetItem.isDummyElement || !this.highlightLayer || targetItem.isFixedPos) return;

			const targetElement = targetItem.element;
			if (this.highlightLayer && targetItem) {
				if (targetItem.highlight === 'light_bg') {
					this.highlightLayer.style.backgroundColor = `rgb(${getCssVarVal(this.dpIntroWrapper, '--highlight-layer-bg-color', '255, 255, 255')})`;
					return;
				}
				else if (targetItem.highlight === 'dark_bg') {
					this.highlightLayer.style.backgroundColor = `rgb(${getCssVarVal(this.dpIntroWrapper, '--highlight-layer-bg-color-darker', '34, 34, 34')})`;
					return;
				}
			}

			let adjusted = false;
			let lightBoxBgColorStr = this.highlightLayer.style.backgroundColor;
			if (!isSecondTry) {
				lightBoxBgColorStr = `rgb(${getCssVarVal(this.dpIntroWrapper, '--highlight-layer-bg-color', '255, 255, 255')})`;
				//if (this.options.dpDebugEn) console.log('Highlight layer bg: '+ lightBoxBgColorStr);
			}

			if (lightBoxBgColorStr) {
				//if (this.options.dpDebugEn) console.log('LightboxBg: ' + lightBoxBgColorStr, isSecondTry);
				const lightBoxBgColor = new Color(lightBoxBgColorStr);
				if (lightBoxBgColor) {

					const textChilds = $(targetElement).find(':visible').add(targetElement);
					if (textChilds) {

						let parentOfTargetEl = $(targetElement).parent();
						if (parentOfTargetEl) parentOfTargetEl = parentOfTargetEl[0];
						const _self = this;
						textChilds.each(function () {
							let opacity = getCssValFloat(this, 'opacity', 1); $(this).css('opacity');

							let beforeOpacity = 1;
							const beforeElStyle = window.getComputedStyle(this, ':before');
							const hasBeforeContent = beforeElStyle.getPropertyValue('content') != 'none';
							if (hasBeforeContent) {
								const beforeOpacityStr = beforeElStyle.getPropertyValue('opacity');
								if (beforeOpacityStr) beforeOpacity = Number(beforeOpacityStr);
							}

							let afterOpacity = 1;
							const afterElStyle = window.getComputedStyle(this, ':after');
							const hasAfterContent = afterElStyle.getPropertyValue('content') != 'none';
							if (hasAfterContent) {
								const afterOpacityStr = afterElStyle.getPropertyValue('opacity');
								if (afterOpacityStr) afterOpacity = Number(afterOpacityStr);
							}
							let isSvg = this.firstChild ? $(this.firstChild).prop('tagName') === 'svg' : false;
							const hasActivePseudoEl = (hasBeforeContent && beforeOpacity > 0) || (hasAfterContent && afterOpacity > 0);

							if (this.firstChild && (this.firstChild.nodeType === Node.TEXT_NODE || isSvg) && opacity > 0 || hasActivePseudoEl) {
								const text = this.textContent;

								let targetColorStr = $(this).css('color');

								if (!text && hasActivePseudoEl) {
									if (hasBeforeContent) targetColorStr = beforeElStyle.getPropertyValue('color');
									else if (hasAfterContent) targetColorStr = afterElStyle.getPropertyValue('color');
								}

								if (targetColorStr) {
									const targetColor = new Color(targetColorStr);
									if (targetColor) {
										// travel up to target element to mix bg
										let finalBg = { r: 0, g: 0, b: 0, a: 0 };
										//let finalBg = new Color('rgba(0, 0, 0, 0)');
										let elToScannBg = this;
										while (elToScannBg && elToScannBg != parentOfTargetEl) {
											const elBgColorStr = $(elToScannBg).css('background-color');
											if (elBgColorStr) {
												const elBgColor = new Color(elBgColorStr);
												if (elBgColor) {
													if (elBgColor.alpha()) {
														//finalBg = finalBg.mix(elBgColor);
														finalBg = normal(colorToRgbaObject(elBgColor), finalBg);
													}
													//if (finalBg.alpha() > 0.9) break;
													if (finalBg.a > 0.9) break;
												}
											}
											elToScannBg = $(elToScannBg).parent();
											if (elToScannBg) elToScannBg = elToScannBg[0];
										}
										//if (finalBg.alpha() < 0.9) {
										if (finalBg.a < 0.9) {
											//const finalBgColorObj = finalBg.mix(lightBoxBgColor);
											const finalBgColorObj = rgbaObjectToColor(normal(colorToRgbaObject(lightBoxBgColor), finalBg));
											const bgLum = finalBgColorObj.luminosity();
											const targetColorLum = targetColor.luminosity();
											//if (this.options.dpDebugEn) console.log('Final bg: ' + targetColor.toString(), isSecondTry);
											//if (this.options.dpDebugEn) console.log('Contrast:', bgLum - targetColorLum);
											const contrast = Math.abs(bgLum - targetColorLum);
											//if (this.options.dpDebugEn) console.log(`contrast:${contrast}`);
											if (contrast < 0.3) {
												//if (this.options.dpDebugEn) console.log(`LOW CONTRAST - text:${text.substr(0, 20)} | contrast:${contrast} | bg:${finalBgColorObj} | color:${targetColor}`);
												//if (this.options.dpDebugEn) console.log('Low contrast');
												if (!isSecondTry) {

													let bgNew;
													if (lightBoxBgColor.isDark()) bgNew = 'rgb(255, 255, 255)';
													else bgNew = 'rgb(34, 34, 34)';
													_self.highlightLayer.style.backgroundColor = bgNew;
													_self.fixTargetLowContrast(targetItem, true);
													adjusted = true;
													return;
												}
												else {
													$(this).addClass(LAYER_CLASSES.colorAdjusted);
													if (!$(this).data('init-color')) $(this).attr('data-init-color', targetColorStr);
													if (lightBoxBgColor.isDark()) {
														$(this).css('color', targetColor.lighten(0.5).rgb().toString());
													}
													else {
														$(this).css('color', targetColor.darken(0.5).rgb().toString());
													}
												}

											}
										}
									}
								}
							}
						});

					}
				}
				if (this.highlightLayer.style.backgroundColor && !isSecondTry && !adjusted) {
					this._removeInlineProp(this.highlightLayer, 'background-color');
				}
			}
		}
		catch (e) {
			console.warn('Exception thrown in fixTargetLowContrast', e.stack);
		}

	}

	_removeInlineProp(elem, propName) {
		if (elem.style.removeProperty) {
			elem.style.removeProperty(propName);
		} else {
			elem.style.removeAttribute(propName);
		}
	}

	_bulletClickCallback = (event) => {
		if (event && event.target && !this.options.disable_navigation_by_bullets) {
			this.goToStep(event.target.closest('li').getAttribute('data-step-number'));
		}
	}

	createButtonContent(textContent) {
		let buttonContentLayer = document.createElement('div');
		buttonContentLayer.className = LAYER_CLASSES.buttonText;
		buttonContentLayer.innerHTML = textContent;
		return buttonContentLayer;
	}

	loadIcons() {
		switch (this.options.labeling.button_arrows) {
			case 'vector': {
				if (!$('.' + LAYER_CLASSES.button + ' .' + LAYER_CLASSES.buttonIco).length) {
					import(/* webpackChunkName: "DPButtonIcon" */ './DPButtonIcon').then(svgLoader => {
						const svgString = svgLoader.default(LAYER_CLASSES.buttonIco);
						if (svgString) {
							$(svgString).appendTo(this.buttonNextLayer);
							$(svgString).prependTo(this.buttonPrevLayer);
						}
					});
				}
			}
				break;
			case 'text':
				$('<span class="' + LAYER_CLASSES.buttonTextIco + '"> &rarr;</span>').appendTo(this.buttonNextLayer);
				$('<span class="' + LAYER_CLASSES.buttonTextIco + '">&larr; </span>').prependTo(this.buttonPrevLayer);
				break;
			default: {
				let spacer = document.createElement('div');
				spacer.className = LAYER_CLASSES.buttonSpacer;
				$(spacer).appendTo(this.buttonNextLayer);
				spacer = document.createElement('div');
				spacer.className = LAYER_CLASSES.buttonSpacer;
				$(spacer).prependTo(this.buttonPrevLayer);
			}
		}
		/*if (this.options.labeling.button_arrows === 'vector' && !$('.' + LAYER_CLASSES.button + ' .' + LAYER_CLASSES.buttonIco).length) {
			import(/* webpackChunkName: "DPButtonIcon" */ /*'./DPButtonIcon').then(svgLoader => {
const svgString = svgLoader.default(LAYER_CLASSES.buttonIco);
if (svgString) {

$(svgString).appendTo(this.buttonNextLayer);
$(svgString).prependTo(this.buttonPrevLayer);
}
});
}
else {
let spacer = document.createElement('div');
spacer.className = LAYER_CLASSES.buttonSpacer;
$(spacer).appendTo(this.buttonNextLayer);
spacer = document.createElement('div');
spacer.className = LAYER_CLASSES.buttonSpacer;
$(spacer).prependTo(this.buttonPrevLayer);
}*/
	}


	initLayers(highlightClass) {

		// Highlight
		this.highlightLayer = document.createElement('div');
		this.highlightLayer.className = highlightClass;
		this.highlightLayer.setAttribute('role', 'presentation');
		this.inHighlightLayerAnimation = new BulletsAnimation(
			'.' + highlightClass,
			'in-highlight-bullets-anim',
			[LAYER_CLASSES.rbAnim, `${LAYER_CLASSES.rbAnim}--in-highlight`], 3, 100);

		this.mainElement.appendChild(this.highlightLayer);

		// Tooltip ref.
		this.tooltipReferenceLayer = document.createElement('div');
		this.tooltipReferenceLayer.className = LAYER_CLASSES.tooltipReference;
		this.tooltipReferenceLayer.setAttribute('role', 'presentation');
		this.mainElement.appendChild(this.tooltipReferenceLayer);

		// Tooltip
		this.tooltipLayer = document.createElement('div');
		this.actualizeTooltipMaxWidth();
		this.tooltipLayer.className = LAYER_CLASSES.tooltip;
		this.tooltipLayer.setAttribute('aria-label', i18n('aria-main', this.mainCfg.i18n));
		this.tooltipLayer.setAttribute('aria-hidden', 'false');
		this.tooltipLayer.setAttribute('role', 'dialog');
		this.tooltipLayer.setAttribute('aria-describedby', 'dpit-tooltip-text');

		this.tooltipReferenceLayer.appendChild(this.tooltipLayer);

		// Tooltip text
		this.tooltipTextLayer = document.createElement('div');
		this.tooltipTextLayer.className = LAYER_CLASSES.tooltipText;
		this.tooltipTextLayer.id = 'dpit-tooltip-text';
		this.tooltipLayer.appendChild(this.tooltipTextLayer);


		// Tooltip arrow
		this.arrowLayer = document.createElement('div');
		this.arrowLayer.className = LAYER_CLASSES.arrow;
		this.arrowLayer.setAttribute('role', 'presentation');
		//this.tooltipLayer.appendChild(this.arrowLayer);
		this.tooltipReferenceLayer.appendChild(this.arrowLayer);

		// Progress bar
		this.progressLayer = document.createElement('div');
		this.progressLayer.className = LAYER_CLASSES.progress;
		if (this.options.showProgress !== true) {
			this.progressLayer.style.display = 'none';
		}
		this.progressBarLayer = document.createElement('div');
		this.progressBarLayer.className = LAYER_CLASSES.progressBar;
		this.progressBarLayer.setAttribute('role', 'progress');
		this.progressBarLayer.setAttribute('aria-valuemin', 0);
		this.progressBarLayer.setAttribute('aria-valuemax', 100);
		this.progressBarLayer.setAttribute('aria-valuenow', this.getProgressInPercent());
		this.progressBarLayer.style.cssText = 'width:' + this.getProgressInPercent() + '%;';
		this.progressLayer.appendChild(this.progressBarLayer);
		this.tooltipLayer.appendChild(this.progressLayer);

		// Tooltip bullets
		this.bulletsLayer = this.createBullets(
			LAYER_CLASSES.bullets,
			this.options.showBullets,
			true,
			0,
			this._bulletClickCallback
		);
		this.actualizeBulletScrollBar();
		this.tooltipLayer.appendChild(this.bulletsLayer);

		// Tooltip buttons
		this.tooltipButtonsLayer = document.createElement('div');
		this.tooltipButtonsLayer.className = LAYER_CLASSES.tooltipButtons;
		if (this.options.showButtons === false) {
			this.tooltipButtonsLayer.style.display = 'none';
		}
		else {

			this.tooltipButtonsLayer.setAttribute('role', 'navigation');
			this.tooltipButtonsLayer.setAttribute('aria-label', i18n('aria-main', this.mainCfg.i18n));
		}

		this.tooltipLayer.appendChild(this.tooltipButtonsLayer);


		//Tooltip number
		this.numberLayer = document.createElement('div');
		this.numberLayer.className = LAYER_CLASSES.number + ' ' + LAYER_CLASSES.hiddenByOpacityAndWidth;
		this.tooltipReferenceLayer.appendChild(this.numberLayer);


		if (this.options.showStepNumbers !== true) {
			$(this.numberLayer).addClass(LAYER_CLASSES.hiddenByOpacityAndWidth);
		}
		else {
			this.numberLayer.setAttribute('aria-label', i18n('aria-main', this.mainCfg.i18n) + ' - ' + i18n('aria-step-num', this.mainCfg.i18n));
		}

		//next button
		this.buttonNextLayer = document.createElement('div');
		this.buttonNextLayer.className = [LAYER_CLASSES.button, LAYER_CLASSES.buttonNext].join(' ');
		$(this.buttonNextLayer).on('click', this.goToNextStep.bind(this));
		this._setAsButton(this.buttonNextLayer, this.options.labeling.nextLabel);
		this.buttonNextLayer.appendChild(this.createButtonContent(this.options.labeling.nextLabel));

		//previous button
		this.buttonPrevLayer = document.createElement('div');
		this.buttonPrevLayer.className = [LAYER_CLASSES.button, LAYER_CLASSES.buttonPrev].join(' ');
		$(this.buttonPrevLayer).on('click', this.goToPreviousStep.bind(this));
		this._setAsButton(this.buttonPrevLayer, this.options.labeling.prevLabel);
		this.buttonPrevLayer.appendChild(this.createButtonContent(this.options.labeling.prevLabel));

		//skip button
		this.buttonSkipLayer = document.createElement('div');
		this.buttonSkipLayer.className = [LAYER_CLASSES.button, LAYER_CLASSES.buttonSkip].join(' ');
		this._setAsButton(this.buttonSkipLayer, this.options.labeling.skipLabel);
		this.buttonSkipLayer.innerHTML = this.options.labeling.skipLabel;
		$(this.buttonSkipLayer).on('click', this.onSkipButtonClick.bind(this));
		this.tooltipButtonsLayer.appendChild(this.buttonSkipLayer);

		//in order to prevent displaying next/previous button always
		if (this.introItems.length >= 1) {
			this.tooltipButtonsLayer.appendChild(this.buttonPrevLayer);
			this.tooltipButtonsLayer.appendChild(this.buttonNextLayer);
		}

		$('html').on('scroll wheel DOMMouseScroll mousewheel touchmove', this.stopAutoScrollWhenUserAction.bind(this));


		this.refreshStepNumber();

		// on layer init event
		this.doAction(EVENTS.onInit);
		this.loadIcons();
	}

	actualizeTooltipMaxWidth() {
		if (this.tooltipLayer) {
			if (this.options.max_tooltip_width
				&& !isNaN(this.options.max_tooltip_width)
				&& (!this.maxScreenArea || this.options.max_tooltip_width < this.maxScreenArea.width)
				&& !this.isStickyTheme()
			) {
				this.tooltipLayer.style.maxWidth = this.options.max_tooltip_width + 'px';
			}
			else {
				this.tooltipLayer.style.maxWidth = '';
			}
		}
	}

	stopAutoScrollWhenUserAction() {
		this.isUserScrolling = true;
		if (this.userInteractTimeout) clearTimeout(this.userInteractTimeout);
		this.userInteractTimeout = setTimeout(() => {
			this.isUserScrolling = false;
		}, 200);
	}

	onSkipButtonClick() {
		this._exitIntro('skip');
	}

	refreshStepNumber(targetItem = null) {
		if (this.options.showStepNumbers === true && this.introItems.length > 1) {
			$(this.numberLayer).removeClass(LAYER_CLASSES.hiddenByOpacityAndWidth);
			this.numberLayer.innerHTML = targetItem ? targetItem.step : '';
		}
		else {
			$(this.numberLayer).addClass(LAYER_CLASSES.hiddenByOpacityAndWidth);
		}
	}

	goToPreviousStep() {
		if (this._currentStep !== 0) {
			this.previousStep();
			return true;
		}
		return false;
	}

	goToNextStep() {
		if (this.introItems.length - 1 !== this._currentStep) {
			this.nextStep();
			return true;
		}
		return false;
	}

	isStickyThemeOnTop = () => {
		return this.isStickyTheme() && $(this.tooltipLayer).hasClass(`${LAYER_CLASSES.tooltip}--on-top`);
	}

	_getStickyTooltipOffset = () => {
		if (this.isStickyTheme()) {
			const tooltipEl = $(this.tooltipLayer);
			if (tooltipEl) {
				const jBulletsEl = $(this.bulletsLayer);
				let bulletsTop = null;
				let bulletsHeight = null;
				if (jBulletsEl && jBulletsEl.length) {
					bulletsTop = getCssValFloat(jBulletsEl, 'top', 0);
					bulletsHeight = jBulletsEl.outerHeight();
				}

				if (tooltipEl.hasClass(`${LAYER_CLASSES.tooltip}--on-top`)) {
					return { top: tooltipEl.outerHeight(), bottom: (bulletsTop === null) ? 0 : bulletsTop };
				}
				else {
					let top = 0;
					if (bulletsTop !== null && bulletsHeight !== null) {
						top = bulletsTop + bulletsHeight;
					}
					return { top: top, bottom: tooltipEl.outerHeight() };
				}
			}
		}
		return { top: 0, bottom: 0 };
	}


	_getFlyingObjectsBB = (targetBB, tooltipBB, numberBB) => {
		if (this.isStickyTheme()) {
			if ($(this.numberLayer).hasClass(LAYER_CLASSES.numberOnTooltip)) return targetBB;
			else return targetBB; //DPBoundingBox.mergeBoundingBoxes(targetBB, numberBB);
		}
		else if (this.options.scrollTo === 'element') {
			return DPBoundingBox.mergeBoundingBoxes(targetBB, numberBB);
		}
		else if (this.options.scrollTo === 'tooltip') {
			return tooltipBB;
		}
		else {
			return DPBoundingBox.mergeBoundingBoxes(targetBB, tooltipBB, numberBB);
		}
	}

	getBottomScrollOffset(flyingObjectsBB, targetBB, tooltipBB, winHeight, fixedTooltipOffset) {
		const isStickyTheme = this.isStickyTheme();
		let scrollOffsetY = flyingObjectsBB.top - ((winHeight / 2) - (flyingObjectsBB.height / 2));
		if (!isStickyTheme && flyingObjectsBB.height - 10 > winHeight) {
			if (tooltipBB.top > targetBB.bottom) {
				scrollOffsetY = flyingObjectsBB.bottom - winHeight + 20;
			}
			else if (tooltipBB.bottom < targetBB.top) {
				scrollOffsetY = flyingObjectsBB.top - 20;
			}
		}
		if (isStickyTheme) {

			if (this.isStickyThemeOnTop()) {
				scrollOffsetY -= fixedTooltipOffset.bottom;
			} else {
				scrollOffsetY -= fixedTooltipOffset.top;
			}
		}


		return scrollOffsetY;
	}


	_getScrollOffset = (targetItem, omitNumberLayer = false) => {
		const scrollOffset = {
			x: null,
			y: null
		};
		if (targetItem && targetItem.scrollTo !== 'off' && this.options.scrollToElement && !targetItem.isDummyElement && !targetItem.isFixedPos) {
			this.actualizeNumberBB();
			const numberBB = !omitNumberLayer && this.options.showStepNumbers === true ? this.numberLayerBB : null;
			this.currentFlyingObjectBB = this._getFlyingObjectsBB(this.targetBB, this.tooltipBB, numberBB);


			if (this.docBB.height > this.winBB.height) {
				const fixedTooltipOffset = this._getStickyTooltipOffset();
				const winHeight = this.winBB.height - (fixedTooltipOffset.top + fixedTooltipOffset.bottom);
				scrollOffset.y = this.getBottomScrollOffset(this.currentFlyingObjectBB, this.targetBB, this.tooltipBB, winHeight, fixedTooltipOffset);
			}

			if (this.docBB.width > this.winBB.width) {
				scrollOffset.x = this.currentFlyingObjectBB.left - ((this.winBB.width / 2) - (this.currentFlyingObjectBB.width / 2));
				if (this.currentFlyingObjectBB.width - 10 > this.winBB.width) {
					if (this.tooltipBB.left > this.targetBB.right) {
						scrollOffset.x = this.currentFlyingObjectBB.right - this.winBB.width + 20;
					}
					else if (this.tooltipBB.right < this.targetBB.left) {
						scrollOffset.x = this.currentFlyingObjectBB.left - 20;
					}
				}
			}

		}
		return scrollOffset;
	}


	_calculateScrollTimeToTargetEl(targetOffset) {

		const startOffset = { left: $(window).scrollLeft(), top: $(window).scrollTop() };
		const dist = Math.max(Math.abs(startOffset.left - targetOffset.x), Math.abs(startOffset.top - targetOffset.y));
		const res = Math.round(Math.min(this.options.maxScrollSpeedPerPageMs, Math.max(350, (dist / this.winBB.height) * this.options.scrollSpeedPerPageMs)));
		/*if (this.options.dpDebugEn) console.log({
			'Scroll time': res,
			maxScrollSpeedPerPageMs: this.options.maxScrollSpeedPerPageMs,
			scrollSpeedPerPageMs: this.options.scrollSpeedPerPageMs
		});*/
		return res;
	}

	tryUnlockActualizeTarget(processFce, processImmediatelyWhenReady = false) {
		if (!this.actualizeTargetLock) {
			if (processFce) {
				this.lockActualizeTarget();
				processFce();
				this.unlockActualizeTarget();
				return true;
			}
		} else {
			if (processImmediatelyWhenReady) this.processFceToRun = processFce;
			return false;
		}
	}

	unlockActualizeTarget() {
		this.actualizeTargetLock = false;
		if (this.processFceToRun) {
			const fceBkp = this.processFceToRun;
			this.processFceToRun = null;
			this.tryUnlockActualizeTarget(fceBkp, false);
		}
	}

	lockActualizeTarget() {
		this.actualizeTargetLock = true;
	}

	_actualizeTargetPositionBasic(targetItem, processImmediatelyWhenReady = true, basicPositionOnly = false, forceShowLayersAfter = false, isFollowTarget = true) {
		if (this.highlightLayer && this.tooltipReferenceLayer) {
			//if (this.options.dpDebugEn) console.log(targetItem.element);
			this.tryUnlockActualizeTarget(() => {
				this.isTargetFollowingFired = true;
				this.pauseFollowTarget();
				this.scrollParentToTarget(targetItem?.element);
				this.setTargetBBs(targetItem);
				this.actualizeUserInteraction(targetItem);
				this.setLayerPosition(this.highlightLayer, null, null, true);
				this.setLayerPosition(this.tooltipReferenceLayer);
				this.placeTooltip(targetItem/*, 2, {}, true*/); // do not iterate tooltip position
				this.startFollowTarget();
				const startStepIdx = this._currentStep;


				if (this.followTargetFinishedTimer) clearTimeout(this.followTargetFinishedTimer);
				if (!basicPositionOnly) {
					this.followTargetFinishedTimer = setTimeout(() => {
						if (startStepIdx === this._currentStep) {
							if (this.options.dpDebugEn) {
								if (isFollowTarget) console.log(`---  STEP ${this._currentStep} FOLLOW TARGET: TARGET CHANGE POSITION: STOPPED ---`);
								else console.log(`---  STEP ${this._currentStep} RESIZE REACTION: STOPPED ---`);
							}
							if (this.currentFlyingObjectBB) {

								const flyingObjIntersectionWithScreen = DPBoundingBox.intersect(this.currentFlyingObjectBB, this.maxScreenArea);
								if (!flyingObjIntersectionWithScreen || DPBoundingBox.area(flyingObjIntersectionWithScreen) < DPBoundingBox.area(this.flyingObjectsBB)) {
									this._actualizeTargetPosition(targetItem, processImmediatelyWhenReady);
									if (forceShowLayersAfter) {
										this.showIntroLayers();
									}
								}
							}
						}


					}, 100);
				} else if (forceShowLayersAfter) {
					this.showIntroLayers();
				}
			}, processImmediatelyWhenReady);
		}
	}

	_actualizeTargetPosition(targetItem, processImmediatelyWhenReady = true) {
		if (this.highlightLayer && this.tooltipReferenceLayer) {
			//if (this.options.dpDebugEn) console.log(targetItem.element);
			this.tryUnlockActualizeTarget(() => {
				this.isTargetFollowingFired = true;
				this.pauseFollowTarget();

				if (!this.actualizeTargetItem(targetItem, this.isCurrentBackward, false)) return; // if step should be skipped
				this.scrollParentToTarget(targetItem?.element);
				this.setTargetBBs(targetItem);
				this.actualizeUserInteraction(targetItem);
				this.setLayerPosition(this.highlightLayer, null, null, true);
				this.setLayerPosition(this.tooltipReferenceLayer);
				this.placeTooltip(targetItem);
				this.startFollowTarget();
				const startStepIdx = this._currentStep;

				if (this.followTargetFinishedTimer) clearTimeout(this.followTargetFinishedTimer);
				this.followTargetFinishedTimer = setTimeout(() => {
					if (startStepIdx === this._currentStep) {
						if (this.options.dpDebugEn) console.log(`---  STEP ${this._currentStep} FOLLOW TARGET: TARGET CHANGE POSITION: STOPPED ---`);
						if (this.currentFlyingObjectBB) {
							if (!this.isScrolling) this.finalizeScrollAndPosition(true);
							else this.finalizeAfterScroll = true;
						}
					}
				}, 100);
			}, processImmediatelyWhenReady);
		}
	}


	finalizeScrollAndPosition(isFromFollowTarget = false) {
		const flyingObjectBBRel = DPBoundingBox.boundingBox2RelativeScrollPos(this.currentFlyingObjectBB, true);
		const flyingObjIntersectionWithScreen = DPBoundingBox.intersect(flyingObjectBBRel, this.maxScreenArea);
		if (!flyingObjIntersectionWithScreen || DPBoundingBox.area(flyingObjIntersectionWithScreen) < DPBoundingBox.area(this.flyingObjectsBB)) {
			this.refresh(isFromFollowTarget);
			return false;
		}
		else {
			this.tryToFinalizeStickyNumberPosition();
		}
		return true;
	}

	tryToFinalizeStickyNumberPosition() {
		if (this.isStickyTheme()) {
			const isTargetInsideMaxScreenArea = this.isElementInsideMaxScreenArea(this.currentTargetItem?.element);
			if (this.isTargetElementInsideMaxScreenArea !== isTargetInsideMaxScreenArea) {
				const desiredNumberPos = {
					x: isTargetInsideMaxScreenArea ? 'right' : 'left',
					y: 'top',
					onTooltip: !isTargetInsideMaxScreenArea
				};
				let scrollToPos = this._getScrollOffset(this.currentTargetItem, true);
				const scrollToPosNotNull = {
					x: scrollToPos.x !== null ? scrollToPos.x : $(window).scrollLeft(),
					y: scrollToPos.y !== null ? scrollToPos.y : $(window).scrollTop(),
				};

				this._placeNumberLayer(this.targetBB, scrollToPosNotNull, this.tooltipPos, desiredNumberPos);
				$(this.numberLayer).addClass(LAYER_CLASSES.gelatinePulse);
			}
			this.isTargetElementInsideMaxScreenArea = isTargetInsideMaxScreenArea;

		}
	}


	_clearContrastAdjustment() {
		$('.' + LAYER_CLASSES.colorAdjusted).each((_, val) => {
			$(val).css('color', $(val).data('init-color'));
			$(val).removeClass(LAYER_CLASSES.colorAdjusted);
		});
		if (this.highlightLayer) this.highlightLayer.style.backgroundColor = '';
	}

	/**
	 * To remove all show element(s)
	 *
	 * @api private
	 * @method resetTargetElement
	 */
	resetTargetElement = () => {
		if (this.currentTargetItem) this.updateIterateAfter(this.currentTargetItem, true);
		this._removePossiblyChangingPositionClassSafe(LAYER_CLASSES.targetParent, [
			LAYER_CLASSES.targetParentFixed,
			LAYER_CLASSES.targetParentFixedChild,
			LAYER_CLASSES.targetParentFixedCloser,
			LAYER_CLASSES.relativePosition].join(' ')
		);
		this._resetInlineStyle();

		var elms = document.querySelectorAll(`.${LAYER_CLASSES.target}`);
		this._forEach(elms, (elm) => {
			const isDummy = elm === this.targetDummy;
			if (elm.className && typeof elm.className === 'string') {
				const classes = elm.className && elm.className.split(/\s+/);
				if (classes && classes.length) {
					classes.forEach((className) => {
						if (className.startsWith('dpit-')) {
							$(elm).removeClass(className);
						}
					});
				}
			}
			else {
				$(elm).removeClass([LAYER_CLASSES.target, LAYER_CLASSES.targetBlockEvents, LAYER_CLASSES.relativePosition]);
			}
			if (isDummy) $(elm).addClass(LAYER_CLASSES.targetDummy);
		});

	}

	/**
	 * To set the show element
	 * This function set a relative (in most cases) position and changes the z-index
	 *
	 * @api private
	 * @method setTargetElement
	 * @param {Object} targetElement
	 */
	setTargetElementClasses = (targetElement) => {
		var parentElm;

		if (targetElement === this.targetDummy) return;

		// we need to add this show element class to the parent of SVG elements
		// because the SVG elements can't have independent z-index
		if (targetElement instanceof SVGElement) {
			parentElm = targetElement.parentNode;

			while (targetElement.parentNode !== null) {
				if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;

				if (parentElm.tagName.toLowerCase() === 'svg') {
					$(parentElm).addClass(LAYER_CLASSES.target);
					this._addPossiblyChangingPositionClassSafe($(parentElm), LAYER_CLASSES.relativePosition);
				}

				parentElm = parentElm.parentNode;
			}
		}
		const isCurrentStepItemInMobileMenu = this.isStepItemInMobileMenu(this.currentTargetItem);
		//const isCurrentStepItemInMobileMenu = false;
		$(targetElement).addClass(LAYER_CLASSES.target);

		let currentElementPosition = $(targetElement).css('position');
		if (currentElementPosition !== 'absolute' &&
			currentElementPosition !== 'relative' &&
			currentElementPosition !== 'sticky' &&
			currentElementPosition !== 'fixed') {
			//change to new intro item
			this._addPossiblyChangingPositionClassSafe($(targetElement), LAYER_CLASSES.relativePosition);
		}



		parentElm = targetElement.parentNode;
		let hasFixedOrAbsParent = false;
		let lastFixedParent = null;
		let wasAnyFixedParent = false;

		while (parentElm !== null) {
			if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;

			//fix The Stacking Context problem.
			//More detail: https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Understanding_z_index/The_stacking_context
			const zIndex = $(parentElm).css('z-index');
			const opacity = getCssValFloat(parentElm, 'opacity', 1);
			const filter = $(parentElm).css('filter');

			//var transform =  $(parentElm).css('transform') ||  $(parentElm).css('-webkit-transform') ||  $(parentElm).css('-moz-transform') ||  $(parentElm).css('-ms-transform') ||  $(parentElm).css('-o-transform');
			const transform = $(parentElm).css('transform');
			const hasTransform = transform !== 'none' && transform !== undefined;
			const hasDecreasedOpacity = opacity < 1;

			if (isCurrentStepItemInMobileMenu || /[0-9]+/.test(zIndex) || hasDecreasedOpacity || filter || hasTransform) {
				const fixClasses = [LAYER_CLASSES.targetParent];
				const cssPosition = $(parentElm).css('position');
				if (isCurrentStepItemInMobileMenu || hasTransform || hasDecreasedOpacity || cssPosition === 'fixed' || cssPosition === 'sticky') {
					fixClasses.push(LAYER_CLASSES.targetParentFixed);
					if (!wasAnyFixedParent) {
						fixClasses.push(LAYER_CLASSES.targetParentFixedCloser);
						wasAnyFixedParent = true;
					}
				}
				if (isCurrentStepItemInMobileMenu || hasTransform || hasDecreasedOpacity || cssPosition === 'fixed' || cssPosition === 'sticky' || cssPosition === 'absolute') {
					hasFixedOrAbsParent = true;
					lastFixedParent = parentElm;
				}
				this._addPossiblyChangingPositionClassSafe($(parentElm), fixClasses.join(' '));
			}
			parentElm = parentElm.parentNode;
		}
		if (hasFixedOrAbsParent) {
			$(this.highlightLayer).addClass(`${LAYER_CLASSES.highlight}--fixed-pos`);
			// set all parents down to the LAYER_CLASSES.targetParentFixedChild
			if (lastFixedParent) {
				$(lastFixedParent).find(`.${LAYER_CLASSES.targetParent}`).addClass(LAYER_CLASSES.targetParentFixedChild);
			}

		}
		else {
			$(this.highlightLayer).removeClass(`${LAYER_CLASSES.highlight}--fixed-pos`);
		}
	}

	_setInlineStyle(element, css) {
		if (element) {

			$(element).addClass('dpit-inline-style-adjusted');
			if (element.style.cssText) element.setAttribute('data-style-bkp', element.style.cssText);
			Object.keys(css).forEach(key => {
				if (element.style.cssText && element.style.cssText[element.style.cssText.length - 1] != ';') element.style.cssText += ';';
				element.style.cssText += `${key}:${css[key]};`;
			});
		}
	}

	_resetInlineStyle() {

		$('.dpit-inline-style-adjusted').each((index, element) => {
			const styleText = $(element).data('style-bkp');
			element.style.cssText = styleText || '';
			$(element).removeClass('dpit-inline-style-adjusted');
		});
	}

	_addPossiblyChangingPositionClassSafe = (jElement, className) => {
		if (jElement.length && !jElement.hasClass(className)) {
			const typePrefix = 'fix';
			this.pauseFollowTarget();
			const element = jElement[0];
			const beforeOffset = jElement.offset();

			jElement.addClass(className);

			const afterOffset = jElement.offset();

			let setOffset = false;
			if (Math.abs(afterOffset.top - beforeOffset.top) > 1) {
				jElement.attr(`data-${typePrefix}-inline-top`, element.style.top);
				setOffset = true;
				//jElement.css('top',beforeOffset.top);
			}

			if (Math.abs(afterOffset.left - beforeOffset.left) > 1) {
				jElement.attr(`data-${typePrefix}-inline-left`, element.style.left);
				setOffset = true;
				//jElement.css('left',beforeOffset.left);
			}
			if (setOffset) {
				jElement.attr(`data-${typePrefix}-inline-position`, element.style.position);
				jElement.offset(beforeOffset);
			}

			this.restoreFollowTarget();
		}
	}

	_restoreInlineStyleAfterAddingPossiblyChangingPositionClass = (element, typePrefix, stylePropName) => {
		const attrName = `data-${typePrefix}-inline-${stylePropName}`;
		if (element.hasAttribute(attrName)) {
			$(element).css(stylePropName, element.getAttribute(attrName));
			element.removeAttribute(attrName);
		}
		else {
			element.removeAttribute(stylePropName);
		}
	}

	_removePossiblyChangingPositionClassSafe = (className, extraClassToRemove = '') => {
		const typePrefix = 'fix';
		this.pauseFollowTarget();
		var fixedElements = document.querySelectorAll('.' + className);
		this._forEach(fixedElements, (element) => {
			$(element).removeClass(className);

			if (extraClassToRemove) $(element).removeClass(extraClassToRemove);
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'left');
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'top');
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'width');
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'height');
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'position');
		});
		this.restoreFollowTarget();
	}

	/**
	* Iterates arrays
	*
	* @param {Array} arr
	* @param {Function} forEachFnc
	* @param {Function} completeFnc
	* @return {Null}
	*/
	_forEach = (arr, forEachFnc, completeFnc) => {
		// in case arr is an empty query selector node list
		if (arr) {
			for (var i = 0, len = arr.length; i < len; i++) {
				forEachFnc(arr[i], i);
			}
		}

		if (typeof (completeFnc) === 'function') {
			completeFnc();
		}
	}

	/**
	 * Checks to see if target element (or parents) position is fixed or not
	 *
	 * @api private
	 * @method isFixedPos
	 * @param {Object} element
	 * @returns Boolean
	 */
	isFixedPos = (element) => {
		if (!element) return false;
		var p = element.parentNode;

		if (!p || p.nodeName === 'HTML') {
			return false;
		}

		if ($(element).css('position') === 'fixed') {
			return true;
		}

		return this.isFixedPos(p);
	}


	// targetElm can be body
	addOverlayLayer = (hidden = false, blurred = false) => {

		if (!this.overlayContainer) {

			this.overlayContainer = document.createElement('div');
			this.overlayContainer.className = classNames({
				[LAYER_CLASSES.overlayContainer]: true,
				[LAYER_CLASSES.hidden]: true
			});

			this.overlayLayer = document.createElement('div');
			this.overlayLayer.className = classNames({
				[LAYER_CLASSES.overlay]: true,
				[`${LAYER_CLASSES.overlay}--${LAYER_CLASSES.overlayBlurredModifier}`]: blurred
			});

			this.overlayLayer.style.opacity = this.options.overlayOpacity;
			this.overlayContainer.appendChild(this.overlayLayer);
			this.overlayContainer.setAttribute('aria-hidden', 'true');
			this.mainElement.appendChild(this.overlayContainer);

			if (!hidden) {
				window.setTimeout(() => {
					this.showOverlay();
				}, 10);
			}
			this.overlayContainerTransitionDelayMs = getTransitionDurationMs(this.overlayContainer);
			this.overlayTransitionDelayMs = getTransitionDurationMs(this.overlayLayer);
		}
		return true;
	}

	/**
	* Find the nearest scrollable parent
	* copied from https://stackoverflow.com/questions/35939886/find-first-scrollable-parent
	*
	* @param Element element
	* @return Element
	*/
	_getScrollParent = (element) => {
		var style = window.getComputedStyle(element);
		var excludeStaticParent = (style.position === 'absolute');
		var overflowRegex = /(auto|scroll)/;

		if (style.position === 'fixed') return document.body;

		for (var parent = element; (parent = parent.parentElement);) {
			style = window.getComputedStyle(parent);
			if (excludeStaticParent && style.position === 'static') {
				continue;
			}
			if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
				//if (this.options.dpDebugEn) console.log('_getScrollParent', parent, style.position, style.overflow, style.overflowY, style.overflowX);
				return parent;
			}
		}

		return document.body;
	}

	scrollParentToTarget = (element, animate = false, scrollInX = true, scrollInY = true, onlyWhenEjected = true, preferPositionOnTheEnd = false) => {
		if (element) {
			// scroll to element
			const scrollContainer = this._getScrollParent(element);
			if (scrollContainer !== document.body) {
				if (this.options.dpDebugEn) console.log('Scroll parent: ' + scrollContainer);
				// target is within a scrollable element	
				const visibleContainerBB = scrollContainer.getBoundingClientRect();
				const elementBB = DPBoundingBox.getElBoundingBox(element, false, true, null, visibleContainerBB.top - scrollContainer.scrollTop, visibleContainerBB.left - scrollContainer.scrollLeft);
				const scrollToOffset = { left: scrollContainer.scrollLeft, top: scrollContainer.scrollTop };

				if (scrollInY && $(scrollContainer).hasScrollBar(false, true) && (!onlyWhenEjected || (elementBB.top <= scrollContainer.scrollTop || elementBB.right >= (scrollContainer.scrollTop + visibleContainerBB.height)))) {
					scrollToOffset.top = elementBB.top;
					if (1.5 * elementBB.height < visibleContainerBB.height) {
						if (preferPositionOnTheEnd) {
							scrollToOffset.top -= (visibleContainerBB.height - 1.5 * elementBB.height);
						}
						else {
							scrollToOffset.top -= elementBB.height / 2;
						}
					}
				}

				if (scrollInX && $(scrollContainer).hasScrollBar(true, false) && (!onlyWhenEjected || (elementBB.left <= scrollContainer.scrollLeft || elementBB.right >= (scrollContainer.scrollLeft + visibleContainerBB.width)))) {
					scrollToOffset.left = elementBB.left;
					if (1.5 * elementBB.width < visibleContainerBB.width) {
						if (preferPositionOnTheEnd) {
							scrollToOffset.left -= (visibleContainerBB.width - 1.5 * elementBB.width);
						}
						else {
							scrollToOffset.left -= elementBB.width / 2;
						}
					}
				}

				// is change?
				if (scrollToOffset.left !== scrollContainer.scrollLeft || scrollToOffset.top !== scrollContainer.scrollTop) {
					if (animate) {
						$(scrollContainer).animate(
							{ scrollLeft: scrollToOffset.left, scrollTop: scrollToOffset.top },
							{
								duration: 100,
								easing: this.options.scrollEasing,
								complete: () => $(element).addClass(LAYER_CLASSES.bulletPulse),
							}
						);
					}
					else {
						scrollContainer.scrollLeft = scrollToOffset.left;
						scrollContainer.scrollTop = scrollToOffset.top;
					}
				}


				/*if (this.options.dpDebugEn) console.log('Scrolling inside parent container:', {
					parentPos: parentPos,
					childPos: childPos,
				});*/
			}
		}
	}

	getProgressInPercent = () => {
		// Steps are 0 indexed
		var currentStep = parseInt((this._currentStep + 1), 10);
		return ((currentStep / (this.introItems.length - this.getNotVisibleStepCnt())) * 100);
	}

	afterScrollOnNewTarget = (isFromFollowTarget, backward) => {
		this.isScrolling = false;
		let willBeRefreshed = false;
		if (this.finalizeAfterScroll) {
			this.finalizeAfterScroll = false;
			willBeRefreshed = !this.finalizeScrollAndPosition();
		}
		if (this.tooltipReferenceLayer && !this.ending && !willBeRefreshed) {
			this.actualizeStickyBullets();
			//this.actualizeBoardSizes();
			// is correctly scrolled to target element
			$(this.overlayLayer).css('opacity', this.options.overlayOpacity);

			const isStickyTheme = this.isStickyTheme();

			const isOnTop = $(this.mainElement).hasClass(`${LAYER_CLASSES.main}--on-top`);

			if (!isFromFollowTarget) {
				this.doAction(EVENTS.afterStepChange, {
					isStickyTheme: isStickyTheme,
					isStickyThemeOnTop: isOnTop && isStickyTheme,
					backward: backward,
					currentStepObj: this.stepObject4Hooks(this.currentTargetItem)
				});
			}
		}
	}



	/* To change the scroll of `window` after highlighting an element*/
	_scrollTo = (scrollToPos, isFromFollowTarget = false, backward = false) => {
		if (this.options.dpDebugEn) console.log('Scroll to: ', scrollToPos);
		let isFlyingObjectInside = false;
		if (this.currentFlyingObjectBB) {
			const currentFlyingObjectBBRel = DPBoundingBox.boundingBox2RelativeScrollPos(this.currentFlyingObjectBB);
			const currentFlyingObjectBBRelArea = DPBoundingBox.area(currentFlyingObjectBBRel);
			const intersection = DPBoundingBox.intersect(currentFlyingObjectBBRel, this.maxScreenArea);
			if (intersection && DPBoundingBox.area(intersection) === currentFlyingObjectBBRelArea) {
				isFlyingObjectInside = true;
			}
		}

		if ((scrollToPos.x !== null || scrollToPos.y !== null) && !((this.isUserScrolling || isFlyingObjectInside) && isFromFollowTarget)) {

			let overlayOpacityAdjusted = false;
			let bulletScrollBarActualized = false;
			let triedToFinalizeStickyNumberPosition = false;
			const duration = this.options.scrollDurationMsOverride >= 0 ? this.options.scrollDurationMsOverride : this._calculateScrollTimeToTargetEl(scrollToPos);
			if (duration > 1.5 * this.overlayTransitionDelayMs) {
				$(this.overlayLayer).css('opacity', this.options.overlayOpacityCoefWhenScroll * this.options.overlayOpacity);
			}
			else {
				overlayOpacityAdjusted = true;
			}
			const scrollToCfg = {};
			if (scrollToPos.x !== null) scrollToCfg.scrollLeft = scrollToPos.x;
			if (scrollToPos.y !== null) scrollToCfg.scrollTop = scrollToPos.y;
			this.isScrolling = true;
			this.finalizeAfterScroll = true;
			$('html').animate(
				scrollToCfg,
				{
					duration: duration,
					easing: this.options.scrollEasing,
					complete: () => this.afterScrollOnNewTarget(isFromFollowTarget, backward),
					progress: (_, __, remainingMs) => {
						if ((0.7 * remainingMs) <= this.overlayTransitionDelayMs) {
							if (!bulletScrollBarActualized) {
								bulletScrollBarActualized = true;
								this.actualizeBulletScrollBar(true, backward);
							}
							if (!overlayOpacityAdjusted) {
								overlayOpacityAdjusted = true;
								$(this.overlayLayer).css('opacity', this.options.overlayOpacity);
							}
							if (!triedToFinalizeStickyNumberPosition) {
								triedToFinalizeStickyNumberPosition = true;
								this.tryToFinalizeStickyNumberPosition();
							}
						}

					}
				}
			);
		}
		else {
			this.actualizeBulletScrollBar(true, backward);
			this.afterScrollOnNewTarget(isFromFollowTarget, backward);
		}
	}


	scrollToTargetItem = (targetItem, isFromFollowTarget = false, backward = false) => {
		const scrollToPos = this._getScrollOffset(targetItem, false);
		this._scrollTo(scrollToPos, isFromFollowTarget, backward);
	}


	/**
	 * Update placement of the intro objects on the screen
	 * @api private
	 */
	refresh = (isFromFollowTarget = false) => {

		if (this.currentTargetItem) {
			if (this.options.dpDebugEn) console.log(`-------------------  STEP REFRESH ${this.currentTargetItem.step} -------------------`);
			this.showStepItem(this.currentTargetItem, true, false, isFromFollowTarget);
		}

		return this;
	}
	/**
	 * Show an element on the page
	 *
	 * @api private
	 * @method showStepItem
	 * @param {Object} targetItem
	 */
	showStepItem = (targetItem, isRefresh = false, backward = false, isFromFollowTarget = false) => {

		if (!isRefresh || isFromFollowTarget) $('html').stop(true, false); // stop scroll animation
		let waitMs = 0;
		if (this.onBeforeShowStepCallback instanceof Function) {
			waitMs = this.onBeforeShowStepCallback(this, targetItem, isRefresh);
		}
		this.stopFollowTarget();
		if (waitMs > 0) {
			setTimeout(() => {
				this.mainThread(targetItem, isRefresh, backward, isFromFollowTarget);
			}, waitMs);
		}
		else {
			this.mainThread(targetItem, isRefresh, backward, isFromFollowTarget);
		}

	}

	mainThread = (targetItem, isRefresh, backward = false, isFromFollowTarget = false) => {
		if (this.options.dpDebugEn) console.log(`-------------------  STEP ${targetItem.step} -------------------`);
		this.tryUnlockActualizeTarget(() => {
			this.currentFlyingObjectBB = null;
			this.isCurrentBackward = backward;
			this.actualizeBoardSizes();
			if (!this.actualizeTargetItem(targetItem, backward, !isFromFollowTarget && !isRefresh)) return; // if step should be skipped

			if (!isFromFollowTarget) this.reInitTarget(targetItem);

			this.reInitLayers(false, targetItem);
			this.scrollParentToTarget(targetItem?.element);
			this.setTargetBBs(targetItem);
			this.actualizeUserInteraction(targetItem);
			this.refreshStepNumber(targetItem);
			this.setTooltipContent(targetItem);
			this.setLayerPosition(this.highlightLayer, null, null, true);
			this.setLayerPosition(this.tooltipReferenceLayer);
			this.setTargetElementClasses(targetItem.element);
			this.fixTargetLowContrast(targetItem);
			this.actualizeButtons();
			this.actualizeBulletsNavig(targetItem);
			this.actualizeAutoFocus(isRefresh);
			this.actualizeProgressBar();
			this.placeTooltip(targetItem);
			this.startFollowTarget();
			this.scrollToTargetItem(targetItem, isFromFollowTarget, backward);
			this.showIntroLayers();

		}, true);

	}

}
